import { Stack, Text } from "@fluentui/react";
import { RootState } from "app/store";
import LinkTo from "components/controls/LinkTo";
import { EValidationSeverity, IValidationMessage } from "components/controls/ValidationView/ValidationView.type";
import {
    bcbs_config_attributeid_BCCAdmin,
    bcbs_config_attributeid_FeeType,
    compareUnderWritingReviewToWithoutDispatch,
    FieldsToLookupByMasterAttributeId,
    getExactValue,
    IFlexibleFieldWithAttributes,
    pepmFeeType,
    Tier1To4
} from "global/Application";
import { ESaveType, ISaveInstruction } from "global/Application/dataActions";
import { AppDataSource } from "global/DataSources/AppDataSource";
import { ArrayToLookup, ArrayToLookupByPredicate, formatDate, Memoize, MemoizeAsync, parseDate } from "global/Utility/TSFunctions";
import {
    bcbs_config_release as IXrmOptions_bcbs_config_release,
    bcbs_groupconfigurationsnapshot as IXrmOptions_bcbs_groupconfigurationsnapshot,
} from "model/AttributeOptionSets.type";
import {
    bcbs_groupconfigurationsnapshot as IXrmTypes_bcbs_groupconfigurationsnapshot,
    opportunity as IXrmTypes_opportunity
} from 'model/CRM';
import { TCategoryName } from "model/CRM.type";
import {
    EBenefitStatus as FAM_EBenefitStatus,
    EGroupConfigurationStatus as FAM_EGroupConfigurationStatus,
    IAccountsReceivable as FAM_IAccountsReceivable,
    IBenefit as FAM_IBenefit,
    IBooleanValue as FAM_IBooleanValue,
    ICategoryBase as FAM_ICategoryBase,
    ICESNumber as FAM_ICESNumber,
    IDateValue as FAM_IDateValue,
    IEntityReferenceValue as FAM_IEntityReferenceValue,
    IFeesAndPremiums as FAM_IFeesAndPremiums,
    IFlexibleField as FAM_IFlexibleField,
    IFlexibleFieldSet as FAM_IFlexibleFieldSet,
    IGroupConfigurationConfig as FAM_IGroupConfigurationConfig,
    IGroupConfigurationData as FAM_IGroupConfigurationData,
    IGroupNumber as FAM_IGroupNumber,
    INonStandard as FAM_INonStandard,
    INumberValue as FAM_INumberValue,
    IPlan as FAM_IPlan,
    IStopLoss as FAM_IStopLoss,
    IStringValue as FAM_IStringValue
} from "model/FlexibleAttributeModel";
import { useHistory } from "react-router";
import { IGroupConfigurationDataProperties } from "views/BlueRelationship/GroupConfigurationProperties/IGroupConfigurationDataProperties";
import { OnRenderDescriptionValidationItem } from "views/BlueRelationship/ValidationDialog/RenderValidationDescription";
import { EDataValidationContext } from "./EDataValicationContext";
import { IDataValidationRules } from "./IDataValidationRules.type";
/* eslint-disable-next-line import/no-webpack-loader-syntax */
import ComparisonEngine from "global/Compare/ComparisonEngine";
import { IGCDataLight } from "global/Reducer/dataSlice";
import {
    $att_$fees_and_premiums_$bcbs_adminfees_calcrateseech_dental_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcrateseech_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcrateseech_vision_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcrateseeplus1child_dental_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcrateseeplus1child_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcrateseeplus1child_vision_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcrateseeplus2dependents_dental_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcrateseeplus2dependents_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcrateseeplus2dependents_vision_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcrateseesp_dental_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcrateseesp_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcrateseesp_vision_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcratesfamily_dental_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcratesfamily_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcratesfamily_vision_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcratessingle_dental_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcratessingle_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcratessingle_vision_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcratestp_dental_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcratestp_id,
    $att_$fees_and_premiums_$bcbs_adminfees_calcratestp_vision_id,
    $att_$fees_and_premiums_$bcbs_attributeset_fee_id,
    $att_$fees_and_premiums_$bcbs_eechpepmpertier_id,
    $att_$fees_and_premiums_$bcbs_eesppepmpertier_id,
    $att_$fees_and_premiums_$bcbs_employeeplus2dependentsrate_id,
    $att_$fees_and_premiums_$bcbs_employeeplusonechildrate_id,
    $att_$fees_and_premiums_$bcbs_familypepmpertier_id,
    $att_$fees_and_premiums_$bcbs_singlepepmpertier_id,
    $att_$fees_and_premiums_$bcbs_tppepmpertier_id,
    $att_$group_configuration_$bcbs_initialenrollment_id,
    $att_$group_configuration_$bcbs_normalenrollment_id,
    $att_$group_configuration_$bcbs_ongoingenrollment_ms_id,
    $att_$plan_$bcbs_plan_calcrateseech_dental_id,
    $att_$plan_$bcbs_plan_calcrateseech_id,
    $att_$plan_$bcbs_plan_calcrateseech_vision_id,
    $att_$plan_$bcbs_plan_calcrateseeplus1child_dental_id,
    $att_$plan_$bcbs_plan_calcrateseeplus1child_id,
    $att_$plan_$bcbs_plan_calcrateseeplus1child_vision_id,
    $att_$plan_$bcbs_plan_calcrateseeplus2dependents_dental_id,
    $att_$plan_$bcbs_plan_calcrateseeplus2dependents_id,
    $att_$plan_$bcbs_plan_calcrateseeplus2dependents_vision_id,
    $att_$plan_$bcbs_plan_calcrateseesp_dental_id,
    $att_$plan_$bcbs_plan_calcrateseesp_id,
    $att_$plan_$bcbs_plan_calcrateseesp_vision_id,
    $att_$plan_$bcbs_plan_calcratesfamily_dental_id,
    $att_$plan_$bcbs_plan_calcratesfamily_id,
    $att_$plan_$bcbs_plan_calcratesfamily_vision_id,
    $att_$plan_$bcbs_plan_calcratessingle_dental_id,
    $att_$plan_$bcbs_plan_calcratessingle_id,
    $att_$plan_$bcbs_plan_calcratessingle_vision_id,
    $att_$plan_$bcbs_plan_calcratestp_dental_id,
    $att_$plan_$bcbs_plan_calcratestp_id,
    $att_$plan_$bcbs_plan_calcratestp_vision_id
} from "model/ConfigAttributeConstants";
import {
    $oset_$boolean_option_set_1_$yes_value,
    $oset_$capital_prime_accumulation_integration_$combined_pharmacy_and_medical_value,
    $oset_$group_configuration_size_indicator_retiree_subgroups_$n_a_id,
    $oset_$its_network_pricing_$not_applicable_id,
    $oset_$medical_drug_pbm_$carve_out_vendor_id,
    $oset_$medical_products_$comprehensive_qhdhp_qualified_high_deductible_health_plan_id,
    $oset_$medical_products_$high_deductible_health_plan_hdhp_id,
    $oset_$medical_products_$qhdhp_qualified_high_deductible_health_plan_id,
    $oset_$network_filing_method_$its_id,
    $oset_$prime_deductible_integration_accumulation_$combined_pharmacy_and_medical_value,
    $oset_$prime_oop_accumulation_integration_him_$combined_pharmacy_and_medical_value,
    $oset_$rx_accumulators_apply_$medical_value,
    $oset_$shared_savings_category_$claims_edits_id,
    $oset_$subgroup_type_$retiree_id,
    $oset_$subgroup_type_$retirees_id
} from "model/ConfigOptionSetConstants";
import {
    $matt_$accounts_receivable_$bcbs_cecapamount_ar_id,
    $matt_$capital_prime_$bcbs_dedintegrationaccum_cp_id,
    $matt_$capital_prime_$bcbs_deductible_cp_id,
    $matt_$capital_prime_$bcbs_oop_cp_id,
    $matt_$capital_prime_$bcbs_oopintegrationaccum_cp_id,
    $matt_$fees_and_premiums_$bcbs_guaranteeenddate_id,
    $matt_$fees_and_premiums_$bcbs_guaranteestartdate_id,
    $matt_$fees_and_premiums_$bcbs_iprpcebillgroup_fp_id,
    $matt_$fees_and_premiums_$bcbs_perscriptonsite_id,
    $matt_$fees_and_premiums_$bcbs_sharedsavings_capamount_id,
    $matt_$fees_and_premiums_$bcbs_sharedsavings_categorycode_id,
    $matt_$fees_and_premiums_$bcbs_sharedsavings_id,
    $matt_$florida_prime_$bcbs_deductible_id,
    $matt_$florida_prime_$bcbs_deductibleintegrationaccumulation_id,
    $matt_$florida_prime_$bcbs_oopaccumulationintegration_id,
    $matt_$florida_prime_$bcbs_outofpocket_id,
    $matt_$group_configuration_$bcbs_agencynpn_id,
    $matt_$group_configuration_$bcbs_agentnpn_id,
    $matt_$group_configuration_$bcbs_aso_groupsizeindicatorretireesubgroups_id,
    $matt_$group_number_$bcbs_cancellationeffectivedate_id,
    $matt_$group_number_$bcbs_subgrouptype_id,
    $matt_$medical_$bcbs_abatherapypayat_id,
    $matt_$medical_$bcbs_attributeset_customnetwork_id,
    $matt_$medical_$bcbs_epo_drgugsarecoveredunder_id,
    $matt_$medical_$bcbs_epo_integrateddrigcaremark_id,
    $matt_$medical_$bcbs_integrateondeductible_id,
    $matt_$medical_$bcbs_integrateonoutofpocket_id,
    $matt_$medical_$bcbs_itsfacilitynetworkpricing_id,
    $matt_$medical_$bcbs_itsprofessionalnetworkpricing_id,
    $matt_$medical_$bcbs_networkfilingmethod_id,
    $matt_$medical_$bcbs_productsid_id,
    $matt_$medical_$bcbs_telehealthid_id,
    $matt_$non_standard_$bcbs_benefitdefinition_id,
    $matt_$non_standard_$bcbs_effectivedate_id,
    $matt_$pharmacy_$bcbs_accumulators_apply_deductible_id,
    $matt_$pharmacy_$bcbs_accumulators_apply_out_of_pocket_id,
    $matt_$telehealth_$bcbs_telehealthid_id
} from "model/MasterAttributeConstants";
import ValidationEngine from "./Validation";

// fnp_bcbs_config_attribute_bcbs_name: string;
export interface ICoverageMapper {
    plan_attributeId: string;
    fnp_attributeId: string;
    fnp_fee_attributeId: string;
    fnp_fee_bccAdminCategory: string;
    fnp?: FAM_IFeesAndPremiums;
    fnp_fieldValue?: FAM_IBooleanValue | null;
    plan?: FAM_IPlan;
    plan_fieldValue?: FAM_IBooleanValue | null;
    fnp_fee?: FAM_IFlexibleFieldSet;
    fnp_fee_fieldValue?: FAM_INumberValue | null;
}

export type TMemo<T> = () => Promise<T>;


type TRelation_AR_FNP = {
    accountsReceivable: FAM_IAccountsReceivable,
    feesAndPremium: FAM_IFeesAndPremiums,
    // last group number that has this relationship
    lastGroupNumber: FAM_IGroupNumber,
    plan: FAM_IPlan
};

export const CoverageMapping: ICoverageMapper[] = [
    {
        // EE / CH - Coverage Levels (Plan - Dental) / EE / CH - Coverage Levels - Dental
        plan_attributeId: $att_$plan_$bcbs_plan_calcrateseech_dental_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcrateseech_dental_id,
        fnp_fee_bccAdminCategory: "Dental",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_eechpepmpertier_id,
    },
    {
        // EE / SP - Coverage Levels (Plan - Dental) / EE / SP - Coverage Levels - Dental
        plan_attributeId: $att_$plan_$bcbs_plan_calcrateseesp_dental_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcrateseesp_dental_id,
        fnp_fee_bccAdminCategory: "Dental",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_eesppepmpertier_id,
    },
    {

        // Employee + 1 (Child) - Coverage Levels (Plan - Dental) / Employee + 1 (Child) - Coverage Levels - Dental
        plan_attributeId: $att_$plan_$bcbs_plan_calcrateseeplus1child_dental_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcrateseeplus1child_dental_id,
        fnp_fee_bccAdminCategory: "Dental",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_employeeplusonechildrate_id,
    },
    {

        // Employee + 2 Dependents - Coverage Levels (Plan - Dental) / Employee + 2 Dependents - Coverage Levels - Dental
        plan_attributeId: $att_$plan_$bcbs_plan_calcrateseeplus2dependents_dental_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcrateseeplus2dependents_dental_id,
        fnp_fee_bccAdminCategory: "Dental",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_employeeplus2dependentsrate_id,
    },
    {

        // Family - Coverage Levels (Plan - Dental) / Family - Coverage Levels - Dental
        plan_attributeId: $att_$plan_$bcbs_plan_calcratesfamily_dental_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcratesfamily_dental_id,
        fnp_fee_bccAdminCategory: "Dental",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_familypepmpertier_id,
    },
    {

        // Single - Coverage Levels (Plan - Dental) / Single - Coverage Levels - Dental
        plan_attributeId: $att_$plan_$bcbs_plan_calcratessingle_dental_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcratessingle_dental_id,
        fnp_fee_bccAdminCategory: "Dental",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_singlepepmpertier_id,
    },
    {

        // TP - Coverage Levels (Plan - Dental) / TP - Coverage Levels - Dental
        plan_attributeId: $att_$plan_$bcbs_plan_calcratestp_dental_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcratestp_dental_id,
        fnp_fee_bccAdminCategory: "Dental",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_tppepmpertier_id,
    },
    {

        // EE / CH - Coverage Levels (Plan - Vision) / EE / CH - Coverage Levels - Vision
        plan_attributeId: $att_$plan_$bcbs_plan_calcrateseech_vision_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcrateseech_vision_id,
        fnp_fee_bccAdminCategory: "Vision",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_eechpepmpertier_id,
    },
    {

        // EE / SP - Coverage Levels (Plan - Vision) / EE / SP - Coverage Levels - Vision
        plan_attributeId: $att_$plan_$bcbs_plan_calcrateseesp_vision_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcrateseesp_vision_id,
        fnp_fee_bccAdminCategory: "Vision",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_eesppepmpertier_id,
    },
    {

        // Employee + 1 (Child) - Coverage Levels (Plan - Vision) / Employee + 1 (Child) - Coverage Levels - Vision
        plan_attributeId: $att_$plan_$bcbs_plan_calcrateseeplus1child_vision_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcrateseeplus1child_vision_id,
        fnp_fee_bccAdminCategory: "Vision",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_employeeplusonechildrate_id,
    },
    {

        // Employee + 2 Dependents - Coverage Levels (Plan - Vision) / Employee + 2 Dependents - Coverage Levels - Vision
        plan_attributeId: $att_$plan_$bcbs_plan_calcrateseeplus2dependents_vision_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcrateseeplus2dependents_vision_id,
        fnp_fee_bccAdminCategory: "Vision",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_employeeplus2dependentsrate_id,
    },
    {

        // Family - Coverage Levels (Plan - Vision) / Family - Coverage Levels - Vision
        plan_attributeId: $att_$plan_$bcbs_plan_calcratesfamily_vision_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcratesfamily_vision_id,
        fnp_fee_bccAdminCategory: "Vision",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_familypepmpertier_id,
    },
    {

        // Single - Coverage Levels (Plan - Vision) / Single - Coverage Levels - Vision
        plan_attributeId: $att_$plan_$bcbs_plan_calcratessingle_vision_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcratessingle_vision_id,
        fnp_fee_bccAdminCategory: "Vision",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_singlepepmpertier_id,
    },
    {

        // TP - Coverage Levels (Plan - Vision) / TP - Coverage Levels - Vision
        plan_attributeId: $att_$plan_$bcbs_plan_calcratestp_vision_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcratestp_vision_id,
        fnp_fee_bccAdminCategory: "Vision",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_tppepmpertier_id,
    },
    {

        // EE / CH - Coverage Levels (Plan - Medical) / EE / CH - Coverage Levels - Medical
        plan_attributeId: $att_$plan_$bcbs_plan_calcrateseech_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcrateseech_id,
        fnp_fee_bccAdminCategory: "Medical",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_eechpepmpertier_id,
    },
    {

        // EE / SP - Coverage Levels (Plan - Medical) / EE / SP - Coverage Levels - Medical
        plan_attributeId: $att_$plan_$bcbs_plan_calcrateseesp_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcrateseesp_id,
        fnp_fee_bccAdminCategory: "Medical",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_eesppepmpertier_id,
    },
    {

        // Employee + 1 (Child) - Coverage Levels (Plan - Medical) / Employee + 1 (Child) - Coverage Levels - Medical
        plan_attributeId: $att_$plan_$bcbs_plan_calcrateseeplus1child_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcrateseeplus1child_id,
        fnp_fee_bccAdminCategory: "Medical",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_employeeplusonechildrate_id,
    },
    {

        // Employee + 2 Dependents - Coverage Levels (Plan - Medical) / Employee + 2 Dependents - Coverage Levels - Medical
        plan_attributeId: $att_$plan_$bcbs_plan_calcrateseeplus2dependents_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcrateseeplus2dependents_id,
        fnp_fee_bccAdminCategory: "Medical",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_employeeplus2dependentsrate_id,
    },
    {

        // Family - Coverage Levels (Plan - Medical) / Family - Coverage Levels - Medical
        plan_attributeId: $att_$plan_$bcbs_plan_calcratesfamily_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcratesfamily_id,
        fnp_fee_bccAdminCategory: "Medical",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_familypepmpertier_id,
    },
    {

        // Single - Coverage Levels (Plan - Medical) / Single - Coverage Levels - Medical
        plan_attributeId: $att_$plan_$bcbs_plan_calcratessingle_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcratessingle_id,
        fnp_fee_bccAdminCategory: "Medical",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_singlepepmpertier_id,
    },
    {

        // TP - Coverage Levels (Plan - Medical) / TP - Coverage Levels - Medical
        plan_attributeId: $att_$plan_$bcbs_plan_calcratestp_id,
        fnp_attributeId: $att_$fees_and_premiums_$bcbs_adminfees_calcratestp_id,
        fnp_fee_bccAdminCategory: "Medical",
        fnp_fee_attributeId: $att_$fees_and_premiums_$bcbs_tppepmpertier_id,
    },
];

interface IPlanWithBenefits {
    plan: FAM_IPlan;
    Medical?: FAM_IBenefit;
    Pharmacy?: FAM_IBenefit;
    Dental?: FAM_IBenefit;
    Telehealth?: FAM_IBenefit;
    HSA?: FAM_IBenefit;
    FSA?: FAM_IBenefit;
    HRA?: FAM_IBenefit;
    Vision?: FAM_IBenefit;
    "Capital Prime"?: FAM_IBenefit;
    "Florida Prime"?: FAM_IBenefit;
}

interface IMemoCache {
    getSnapshotsMemoizedAsync?: () => Promise<IXrmTypes_bcbs_groupconfigurationsnapshot[]>,
    getOpportunityMemoizedAsync?: () => Promise<IXrmTypes_opportunity | undefined>,
}

export async function ValidateDataAsync(
    state: RootState,
    rules: IDataValidationRules,
    context: EDataValidationContext,
    history: ReturnType<typeof useHistory>,
    saveInstructions: ISaveInstruction,
    dataSource: AppDataSource,
    cache?: IMemoCache,
) {


    // Caching function to store the master attributes for each entity
    // entity -> {master_attribute_id -> [field1,
    //  field2, ...]}
    // creates a closure to store the master attributes for a given entity
    const _entityFieldsMemoLookup: Record<string, (...par: never[]) => Record<string, IFlexibleFieldWithAttributes[]>> = {};

    const getFieldsMemoByEntity = (
        entity: FAM_IFlexibleFieldSet | FAM_IFeesAndPremiums | FAM_IAccountsReceivable | FAM_IGroupNumber | FAM_IGroupConfigurationData | FAM_ICategoryBase | FAM_INonStandard
    ) => {
        // map to array of master attributes, first element in array being the visible one and memoize so we only run it once if we need to access it multiple times
        let memo = _entityFieldsMemoLookup[entity.id];

        if (!memo)
            _entityFieldsMemoLookup[entity.id] = memo = Memoize(() => {
                return FieldsToLookupByMasterAttributeId(stateConfig, entity.fields);
            });

        return memo;
    };

    const getSnapshotsMemoizedAsync = cache?.getSnapshotsMemoizedAsync ?? MemoizeAsync(async () =>
        await dataSource.getGroupConfigurationSnapshotsForAccount(state.data.account?.accountid!)
    );

    const getOpportunityMemoizedAsync = cache?.getOpportunityMemoizedAsync ?? MemoizeAsync(async () => {
        if (state.data.snapshot._bcbs_opportunityid_value)
            return await dataSource.opportunities_byId_getAsync(state.data.snapshot._bcbs_opportunityid_value)
    });

    const getSBCsNotReadyMemoizedAsync = MemoizeAsync(async () => {
        return await dataSource.bcbs_sbcs_byNotReady_getAsync(state.data.snapshot.bcbs_groupconfigurationsnapshotid!);
    });

    const validateAttributeSet = (
        entity: FAM_IFlexibleFieldSet,
        list: FAM_IFlexibleFieldSet[],
        parent:
            { type: 'groupConfiguration', groupConfiguration: FAM_IGroupConfigurationData } |
            { type: 'benefit', benefit: FAM_IBenefit } |
            { type: 'feesAndPremium', feesAndPremium: FAM_IFeesAndPremiums } |
            { type: 'stopLoss', stopLoss: FAM_IStopLoss } |
            { type: 'accountsReceivable', accountsReceivable: FAM_IAccountsReceivable }
    ) => {


    }

    const stateJson: FAM_IGroupConfigurationData = state.data.json;
    const stateSnapshot: IXrmTypes_bcbs_groupconfigurationsnapshot = state.data.snapshot;
    const stateConfig: FAM_IGroupConfigurationConfig = state.data.config;

    const getOptionSetValueByMasterAttributeId = (benefit: FAM_IBenefit, masterAttributeId: string): [number | null, FAM_IFlexibleField | null] => {
        const field = getFieldsMemoByEntity(benefit)()[masterAttributeId]?.[0]?.field;

        const value = field?.values?.[0]?.value;

        if (value?.type === 'optionset')
            return [value.value, field];

        if (value?.type === 'entity')
            return [stateConfig.cache.map_bcbs_config_optionsetitems[value.id]?.bcbs_value ?? null, field];

        return [null, null];
    };

    const getOptionSetGuidByMasterAttribute = (benefit: FAM_IBenefit, masterAttributeId: string): [string | null, FAM_IFlexibleField | null] => {
        const field = getFieldsMemoByEntity(benefit)()[masterAttributeId]?.[0]?.field;

        const value = field?.values?.[0]?.value;

        if (value?.type === 'entity')
            return [value.id, field];

        return [null, null];
    };

    const getBooleanByMasterAttributeId = (benefit: FAM_IBenefit, masterAttributeId: string): [boolean | null, FAM_IFlexibleField | null] => {
        const field = getFieldsMemoByEntity(benefit)()[masterAttributeId]?.[0]?.field;

        const value = field?.values?.[0]?.value;

        if (value?.type === 'bool')
            return [value.value, field];

        return [null, null];
    };

    const checkRelatedToGroupNumber = true

    const uniqueEntityNameValidations: IValidationMessage[] = [];
    const refValidations: IValidationMessage[] = [];
    const coverageValidations: IValidationMessage[] = [];
    const grandFatherValidations: IValidationMessage[] = [];
    const planGroupStructureValidations: IValidationMessage[] = [];
    const relatedToGroupNumberValidations: IValidationMessage[] = [];
    const billingOnlyPlanValidations: IValidationMessage[] = [];
    const dataValidations: IValidationMessage[] = [];
    const requiredFieldsValidations: IValidationMessage[] = [];
    const releaseValidations: IValidationMessage[] = [];

    const otherValidations: IValidationMessage[] = [];


    // Group Structure ---- 
    // This may need optimizations
    const refGroupNumberCESValidation: IValidationMessage[] = [];
    const refGroupNumberPlanValidation: IValidationMessage[] = [];
    const refGroupNumberStopLossValidation: IValidationMessage[] = [];
    const refGroupNumberAccountsReceivableValidation: IValidationMessage[] = [];
    const refDepartmentCESValidation: IValidationMessage[] = [];

    const resultValidations = {
        refValidations,
        uniqueEntityNameValidations,
        coverageValidations,
        grandFatherValidations,
        planGroupStructureValidations,
        billingOnlyPlanValidations,
        releaseValidations,
        relatedToGroupNumberValidations,
        requiredFieldsValidations,
        dataValidations,
        validationMessages: otherValidations,
    };

    let planLookup: Record<string, FAM_IPlan> = {};
    let benefitLookup: Record<string, FAM_IBenefit> = {};
    let feesAndPremiumLookup: Record<string, FAM_IFeesAndPremiums> = {};
    let stopLossLookup: Record<string, FAM_IStopLoss> = {};
    let accountsReceivableLookup: Record<string, FAM_IAccountsReceivable> = {};
    let groupNumbersLookup: Record<string, FAM_IGroupNumber[]> = {};
    let cesLookup: Record<string, FAM_ICESNumber> = {};

    // {plan1_id -> {Medical:benefit1, Dental:benefit2, ...}}
    const r_plan_benefits: Record<string, IPlanWithBenefits> = {};

    // {plan1_id -> [group_number_1, group_number2, ...]}
    const r_pl_gns: Record<string, { groupNumber: FAM_IGroupNumber, plan: FAM_IPlan }[]> = {};

    // {stoploss1_id -> [group_number_1, group_number2, ...]}
    const r_sl_gns: Record<string, { groupNumber: FAM_IGroupNumber, stopLoss: FAM_IStopLoss }[]> = {};

    // {ar1_id -> [group_number_1, group_number2, ...]}
    const r_ar_gns: Record<string, { groupNumber: FAM_IGroupNumber, accountsReceivable: FAM_IAccountsReceivable }[]> = {};

    // {plan1_id -> {ces_number_1 -> {group_number_1, group_number_2}, ces_number_2 -> ..., }
    const r_pl_ces_gn: Record<string, Record<string, FAM_IGroupNumber>> = {}

    // {ar_id + / + feesAndPremium_id -> {account_receivable, feesAndPremium, plan}}}
    const r_ar_fnp_id: Record<string, TRelation_AR_FNP> = {};

    // {ar_id -[{account_receivable1, feesAndPremium1, plan1}, account_receivable1, feesAndPremium2, plan2}] } }
    const r_ar_fnp: Record<string, TRelation_AR_FNP[]> = {};

    // {fnp_id -> [plan1, plan2, ...]}
    const r_fnp_pl: Record<string, FAM_IPlan[]> = {};

    // Coverage ----
    // planId -> CoverFields following coverage mapping layout
    const plansCoverageFields = {} as Record<string, typeof CoverageMapping>;
    const feesAndPremiumsCoverages = {} as Record<string, typeof CoverageMapping>;

    // Validation Edit - Hard Edit when Fees and Premiums are present but not related to a Plan.
    // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/550985
    // Reps are unable to submit (DEC) when there is a Fee and Premium record present but is not related to a Plan.
    const ignoreFNPAndPlanAssociationCheck =
        stateJson.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Initial Setup(808900002)"].value ||
        stateJson.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Benefit Change(808900000)"].value ||
        stateJson.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Benefit Renewal(808900010)"].value ||
        stateJson.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Administrative Change(808900003)"].value;


    const isAdminChange = stateJson.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Administrative Change(808900003)"].value;

    // Validation Edit - Shared Savings - Claims Cap must match appearing on benefit renewal
    // Claims Cap edit validation should only appear on financial changes/renewals and comprehensive changes/renewals.
    // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/570033
    const validateClaimsCap =
        stateJson.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Financial Change(808900006)"].value ||
        stateJson.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Financial Renewal(808900011)"].value ||
        stateJson.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Comprehensive Change(808900004)"].value ||
        stateJson.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Comprehensive Renewal(808900001)"].value;

    const ignoreNPNCheck =
        stateJson.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Financial Change(808900006)"].value ||
        stateJson.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Financial Renewal(808900011)"].value ||
        stateJson.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Stop Loss(808900009)"].value;

    // Calculate if the snapshot is in a post UWRC status
    const isPostUWRC =
        stateSnapshot.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Gold Standard(808900006)'].value ||
        stateSnapshot.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Data Entry Complete(808900000)'].value ||
        stateSnapshot.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Retired(808900001)'].value ||
        stateSnapshot.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['MNIL Underwriting Complete(808900004)'].value ||
        stateSnapshot.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Merged and Closed(808900010)'].value ||
        stateSnapshot.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Cancelled(808900011)'].value ||
        stateSnapshot.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Transferred to Other LOB(808900012)'].value ||
        stateSnapshot.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Inactive(808900002)'].value;

    const isCancellationConfiguration =
        stateSnapshot.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Cancelled(808900011)'].value ||
        stateSnapshot.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Cancellation in Progress(808900013)'].value;
    // stateSnapshot.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Transferred to Other LOB(808900012)'].value;

    // Lookups -----------------------------------------------------
    planLookup = ArrayToLookup(stateJson.plans)
    benefitLookup = ArrayToLookup(stateJson.benefits);
    feesAndPremiumLookup = ArrayToLookup(stateJson.feesAndPremiums);
    stopLossLookup = ArrayToLookup(stateJson.stopLoss);
    accountsReceivableLookup = ArrayToLookup(stateJson.claimsARs);
    cesLookup = ArrayToLookup(stateJson.groupStructure.cesNumbers);
    groupNumbersLookup = {};

    stateJson.groupStructure.groupNumbers.forEach(eachGroupNumber => {

        if (eachGroupNumber.planRef) {

            const foundPlan = planLookup[eachGroupNumber.planRef.id];

            if (foundPlan && !eachGroupNumber.deactivated && !foundPlan.deactivated) {
                const t = r_pl_gns[eachGroupNumber.planRef.id] ?? [];
                t.push({
                    groupNumber: eachGroupNumber,
                    plan: foundPlan
                });
                r_pl_gns[eachGroupNumber.planRef.id] = t;
            }
        }

        if (eachGroupNumber.stopLossRef) {

            const foundStopLoss = stopLossLookup[eachGroupNumber.stopLossRef.id];

            if (foundStopLoss && !eachGroupNumber.deactivated && !foundStopLoss.deactivated) {
                const t = r_sl_gns[eachGroupNumber.stopLossRef.id] ?? [];
                t.push({
                    groupNumber: eachGroupNumber,
                    stopLoss: foundStopLoss
                });
                r_sl_gns[eachGroupNumber.stopLossRef.id] = t;
            }
        }

        if (eachGroupNumber.accountsReceivableRef) {

            const foundAccountsReceivable = accountsReceivableLookup[eachGroupNumber.accountsReceivableRef.id];

            if (foundAccountsReceivable && !eachGroupNumber.deactivated && !foundAccountsReceivable.deactivated) {
                const t = r_ar_gns[eachGroupNumber.accountsReceivableRef.id] ?? [];
                t.push({
                    groupNumber: eachGroupNumber,
                    accountsReceivable: foundAccountsReceivable,
                });
                r_ar_gns[eachGroupNumber.accountsReceivableRef.id] = t;
            }
        }

        if (!eachGroupNumber.deactivated) {
            const gn = eachGroupNumber.groupNumber ?? '?'
            const t = groupNumbersLookup[gn] ?? [];
            t.push(eachGroupNumber);
            groupNumbersLookup[gn] = t;
        }


        if (eachGroupNumber.planRef && eachGroupNumber.cesNumberRef) {
            const gpNumbers = r_pl_ces_gn[eachGroupNumber.planRef.id] ?? {};
            gpNumbers[eachGroupNumber.cesNumberRef.id] = eachGroupNumber;
            r_pl_ces_gn[eachGroupNumber.planRef.id] = gpNumbers;
        }


        // Plan, FeesAndPremium, AccountsReceivable Relationship
        if (!eachGroupNumber.deactivated) {

            const plan = eachGroupNumber?.planRef?.id ? planLookup[eachGroupNumber.planRef.id] : null;
            const feesAndPremium = plan?.feesAndPremiumsRef?.id ? feesAndPremiumLookup[plan.feesAndPremiumsRef.id] : null;
            const accountsReceivable = eachGroupNumber?.accountsReceivableRef?.id ? accountsReceivableLookup[eachGroupNumber.accountsReceivableRef.id] : null;

            if (plan && feesAndPremium && accountsReceivable) {

                const obj: TRelation_AR_FNP = {
                    plan: plan,
                    feesAndPremium: feesAndPremium,
                    accountsReceivable: accountsReceivable,
                    lastGroupNumber: eachGroupNumber
                }

                r_ar_fnp_id[accountsReceivable.id + "/" + feesAndPremium?.id] = obj;

                const fees = r_ar_fnp[accountsReceivable.id] ?? [];

                // only add if feesAndPremium is not already in the list
                if (fees.length === 0)
                    fees.push(obj);
                else if (!fees.some(t => t.feesAndPremium.id === feesAndPremium.id))
                    fees.push(obj);

                r_ar_fnp[accountsReceivable.id] = fees;
            }

        }
    });

    stateJson.plans.forEach(eachPlan => {

        // Plan -> Fees And Premium
        // --------------------------------
        if (eachPlan.feesAndPremiumsRef) {
            const key = eachPlan.feesAndPremiumsRef.id;
            const t = r_fnp_pl[key] ?? [];
            t.push(eachPlan);
            r_fnp_pl[key] = t;
        }

        // Plan -> Benefits
        // --------------------------------
        {
            const r_plan_benefit: IPlanWithBenefits = r_plan_benefits[eachPlan.id] = {
                plan: eachPlan,
            };

            eachPlan.benefitRefs.forEach(benefitRef => {
                const benefit = benefitLookup[benefitRef.id];
                const category = benefit.bcbs_name as TCategoryName;
                r_plan_benefit[category as keyof IPlanWithBenefits] = benefit as any;
            });
        }
    });

    // Group Configuration | Fields
    // -------------------------------------------------------
    {
        // map to array of master attributes, first element in array being the visible one and memoize so we only run it once if we need to access it multiple times
        const getFieldsMemo = getFieldsMemoByEntity(stateJson);

        if (rules.checkRequiredFields) {

            // TODO replace fields with getFieldsMemoByEntity and test
            const fields = ArrayToLookupByPredicate(stateJson.fields, t => t.configRef.id);

            // Initial Enrollment
            // https://bcbsonline.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=cea36909-d05d-ec11-8f8f-000d3a5a062b
            const bcbs_initialenrollment = fields[$att_$group_configuration_$bcbs_initialenrollment_id];

            // Ongoing (Normal) Enrollment
            // https://bcbsonline.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=10a46909-d05d-ec11-8f8f-000d3a5a062b
            const bcbs_normalenrollment = fields[$att_$group_configuration_$bcbs_normalenrollment_id];

            const bcbs_normalenrollment_value = bcbs_normalenrollment?.values?.[0].value?.type;

            // Ongoing Enrollment
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=efcdc923-ca54-ef11-a317-000d3a17460e
            // Multiselect Option Set
            const bcbs_ongoingenrollment_ms = fields[$att_$group_configuration_$bcbs_ongoingenrollment_ms_id];

            const bcbs_ongoingenrollment_ms_value = bcbs_ongoingenrollment_ms?.values?.[0].value?.type === 'multioptionset'
                ? bcbs_ongoingenrollment_ms?.values?.[0].value.value
                : null;

            // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/453284
            // The Initial Enrollment and Ongoing Enrollment Types must be completed in order for E&M Tasks to generate
            // User should not be able to mark the Configuration as DEC until the fields are populated.
            if (!bcbs_initialenrollment.values?.[0].value?.type)
                requiredFieldsValidations.push({
                    title: `Initial Enrollment field must be completed to proceed.`,
                    type: EValidationSeverity.error,
                    description: `The Initial Enrollment must be completed in order for E&M Tasks to generate and for E&M to know how Enrollment will be received.`,
                });


            if (!bcbs_normalenrollment_value && !bcbs_ongoingenrollment_ms_value)
                requiredFieldsValidations.push({
                    title: `Ongoing Enrollment fields must be completed to proceed.`,
                    type: EValidationSeverity.error,
                    description: `The Ongoing Enrollment Types must be completed in order for E&M Tasks to generate and for E&M to know how Enrollment will be received.`,
                });

            // Agent Number
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=282efbb7-be5d-ec11-8f8f-000d3a5a0d43
            // const bcbs_agentnumber = getFieldsMemo()['7086c361-d18d-ec11-b400-0022480a93ed'];

            // Agency Number
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=d82efbb7-be5d-ec11-8f8f-000d3a5a0d43
            // const bcbs_agencynumber = getFieldsMemo()['d82efbb7-be5d-ec11-8f8f-000d3a5a0d43'];


            // Validation Edit - Present Hard Error when Agent NPN and Agency NPN is not populated
            // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/602727
            if (!ignoreNPNCheck) {
                // Agency NPN
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=9478dfba-f2ee-ef11-9341-7c1e52152397
                const bcbs_agencyNPN = getFieldsMemo()[$matt_$group_configuration_$bcbs_agencynpn_id];

                // field visible?
                const bcbs_agencyNPNField = bcbs_agencyNPN?.[0]?.field;

                if (bcbs_agencyNPNField)
                    if (!bcbs_agencyNPNField.visibility || ((bcbs_agencyNPNField.visibility as number) === 0)) {
                        if ((!(bcbs_agencyNPNField.values?.[0]?.value as FAM_IStringValue)?.value)) {
                            requiredFieldsValidations.push({
                                title: `Agency NPN field must be completed to proceed.`,
                                type: EValidationSeverity.error,
                                description: `The Agency NPN field must be completed. Group Configuration Attributes >> Sales And Marketing >> NPN`,
                            });
                        }
                    }
            }

            // Validation Edit - Present Hard Error when Agent NPN and Agency NPN is not populated
            // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/602727
            if (!ignoreNPNCheck) {
                // Agent NPN
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=86b2954e-f1ee-ef11-9341-7c1e52152397
                const bcbs_agentnpn = getFieldsMemo()[$matt_$group_configuration_$bcbs_agentnpn_id];

                // field visible?
                const bcbs_agentnpnField = bcbs_agentnpn?.[0]?.field;

                if (bcbs_agentnpnField)
                    if (!bcbs_agentnpnField.visibility || ((bcbs_agentnpnField.visibility as number) === 0)) {
                        if ((!(bcbs_agentnpnField.values?.[0]?.value as FAM_IStringValue)?.value)) {
                            requiredFieldsValidations.push({
                                title: `Agent NPN field must be completed to proceed.`,
                                type: EValidationSeverity.error,
                                description: `The Agent NPN field must be completed. Group Configuration Attributes >> Sales And Marketing >> NPN`,
                            });
                        }
                    }
            }

        }

        if (rules.checkData) {
            if (!stateJson.bcbs_shortname || stateJson.bcbs_shortname.trim() === '')
                dataValidations.push({
                    title: `Group Configuration's Short Name is required.`,
                    type: EValidationSeverity.error,
                    description: `The Short Name field is required and cannot be empty.\nYou can update configuration's short name using properties at root level.`,
                });
        }

    }

    // Group Configuration | NonStandards
    // -------------------------------------------------------
    stateJson.nonStandards.forEach(eachNonStandard => {
        // nothing to do for now
        return;
    });

    // Group Configuration | Attributeset ?
    // -------------------------------------------------------
    stateJson.attributeSets.forEach(eachAttributeSet => {
        // nothing to do for now
        return;
    });

    // Plans
    // -------------------------------------------------------
    stateJson.plans.forEach(eachPlan => {
        // TODO use memo and cache this on use
        // lets only build this if needed for the context
        let fieldMap: Record<string, FAM_IFlexibleField> | null = null;

        if (!fieldMap)
            if (rules.checkCoverage)
                fieldMap = ArrayToLookupByPredicate(eachPlan.fields, (t) => t.configRef.id);

        const planWithBenefits = r_plan_benefits[eachPlan.id];

        // Validation Edit - When Medical Product is a QHDHP product present a VE when Pharmacy Integrated Accumulators do not align
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/734334
        // When Medical Product is a QHDHP product present a VE when the Accumulator section on the related Pharmacy/FL Prime/Capital Prime
        // does not reflect that the Pharmacy Deductible and OOP use the Medical Deductible and OOP Amounts.
        // This needs to be a warning as there is the possibility that the Group uses a Pharmacy Deductible or OOP amount that aligns with // the government mandated minimums.
        // --------------------------------------------------------------------------------------------------------------

        // Med Products
        // bcbs_productsid
        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=818b0bc2-a215-ed11-b83c-00224820a835&newWindow=true&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=3f91d4e1-c24b-ec11-8f8e-000d3a3340f2
        // optionset: Blue Rx with mail order MG Groups Only(20), BlueHPN(17), BlueRx without mail order MG Groups Only(21), Chamber(27), Comprehensive(14), Comprehensive QHDHP (Qualified High Deductible Health Plan)(32), Coupe Health - Financial(30), Coupe Health - non-Financial(31), Dental(2), EPO (Limited OON)(28), EPO (Limited OON)(28), Exclusive Provider Organization (EPO)(3), Flexible Spending Account (FSA)(22), Freestanding Vision(4), Health Reimbursement Account (HRA)(5), Health Savings Account (HSA)(6), Healthy Vision(23), High Deductible Health Plan (HDHP)(15),  HMO(7), HMO - QHDHP (Qualified High Deductible Health Plan)(50),  Integrated Rx w/o Mail Order(18), Integrated Rx with Mail Order(8), Integrated Rx without mail order(24), Level Funded PPO(16), Med_Product(25), Pharmacy Carve-In(9), PPO(10), Preferred Blue(11), QHDHP (Qualified High Deductible Health Plan)(19), Tiered EPO(12), Tiered EPO (Limited OON)(29), Tiered PPO(1), True Blue Marketplace(13), Vision under Health(26).
        if (rules.checkData && !eachPlan.deactivated) {
            const medicalBenefit = planWithBenefits.Medical;

            if (medicalBenefit &&
                !medicalBenefit.deactivated &&
                medicalBenefit.status.value !== FAM_EBenefitStatus.Cancelled
            ) {
                const [medicalProduct_optionsetId, _] = getOptionSetGuidByMasterAttribute(medicalBenefit, $matt_$medical_$bcbs_productsid_id);

                const valid_medicalProduct_optionsetIds = [
                    $oset_$medical_products_$comprehensive_qhdhp_qualified_high_deductible_health_plan_id,
                    $oset_$medical_products_$qhdhp_qualified_high_deductible_health_plan_id,
                    $oset_$medical_products_$high_deductible_health_plan_hdhp_id
                ];

                if (valid_medicalProduct_optionsetIds.includes(medicalProduct_optionsetId ?? '')) {

                    const optumBenefit = planWithBenefits.Pharmacy;
                    const floridaBenefit = planWithBenefits['Florida Prime'];
                    const capitalBenefit = planWithBenefits['Capital Prime'];

                    // Pharmacy: Optum
                    // Build: Attribute: Information: Apply Deductible - Dynamics 365 | Build: Option Set: Information: Rx - Accumulators Apply - Dynamics 365 = 100000000 - Medical
                    // and Build: Attribute: Information: Apply Out of Pocket - Dynamics 365 | Build: Option Set: Information: Rx - Accumulators Apply - Dynamics 365 = 100000000 - Medical
                    // ------------------------------
                    // Apply Deductible
                    // bcbs_accumulators_apply_deductible
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=15ba3002-7160-ec11-8f8f-000d3a5a07fc
                    // optionsetitem: 
                    // Medical(100000000),
                    // None(100000002),
                    // Pharmacy(100000001)
                    let hasIncorrectOptumAccumulators = false;
                    if (optumBenefit &&
                        !optumBenefit.deactivated &&
                        optumBenefit.status.value !== FAM_EBenefitStatus.Cancelled
                    ) {
                        const [optumApplyDeductible,] = getOptionSetValueByMasterAttributeId(optumBenefit, $matt_$pharmacy_$bcbs_accumulators_apply_deductible_id);
                        const [optumApplyOutOfPocket,] = getOptionSetValueByMasterAttributeId(optumBenefit, $matt_$pharmacy_$bcbs_accumulators_apply_out_of_pocket_id);

                        hasIncorrectOptumAccumulators = (
                            optumApplyDeductible !== $oset_$rx_accumulators_apply_$medical_value ||
                            optumApplyOutOfPocket !== $oset_$rx_accumulators_apply_$medical_value
                        );
                    }

                    // Pharmacy: Florida Prime
                    // Build: Option Set: Information: Prime Deductible Integration Accumulation - Dynamics 365 | Build: Option Set: Information: Boolean Option Set 1 - Dynamics 365 = 10 - Yes; 
                    // and Build: Attribute: Information: Deductible Integration Accumulation - Dynamics 365 | Build: Option Set: Information: Prime Deductible Integration Accumulation - Dynamics 365 = 20 - Combined Pharmacy and Medical
                    // and
                    // Build: Attribute: Information: Out of Pocket (Standard) - Dynamics 365 |  Build: Option Set: Information: Boolean Option Set 1 - Dynamics 365 = 10 - Yes;
                    // and Build: Attribute: Information: OOP Accumulation Integration (Standard) - Dynamics 365 | Build: Option Set: Information: Prime OOP Accumulation Integration (Standard) - Dynamics 365 = 20 - Combined Pharmacy and Medical
                    let hasIncorrectFloridaPrimeAccumulators = false;
                    if (floridaBenefit &&
                        !floridaBenefit.deactivated &&
                        floridaBenefit.status.value !== FAM_EBenefitStatus.Cancelled
                    ) {
                        const [floridaPrimeDeductible,] = getOptionSetValueByMasterAttributeId(floridaBenefit, $matt_$florida_prime_$bcbs_deductible_id);
                        const [floridaPrimeDeductibleIntegrationAccumulation,] = getOptionSetValueByMasterAttributeId(floridaBenefit, $matt_$florida_prime_$bcbs_deductibleintegrationaccumulation_id);
                        const [floridaPrimeOutOfPocket,] = getOptionSetValueByMasterAttributeId(floridaBenefit, $matt_$florida_prime_$bcbs_outofpocket_id);
                        const [floridaPrimeOutOfPocketIntegrationAccumulation,] = getOptionSetValueByMasterAttributeId(floridaBenefit, $matt_$florida_prime_$bcbs_oopaccumulationintegration_id);

                        hasIncorrectFloridaPrimeAccumulators = (
                            floridaPrimeDeductible !== $oset_$boolean_option_set_1_$yes_value ||
                            (floridaPrimeDeductible === $oset_$boolean_option_set_1_$yes_value &&
                                floridaPrimeDeductibleIntegrationAccumulation !== $oset_$prime_deductible_integration_accumulation_$combined_pharmacy_and_medical_value) ||
                            floridaPrimeOutOfPocket !== $oset_$boolean_option_set_1_$yes_value ||
                            (floridaPrimeOutOfPocket === $oset_$boolean_option_set_1_$yes_value &&
                                floridaPrimeOutOfPocketIntegrationAccumulation !== $oset_$prime_oop_accumulation_integration_him_$combined_pharmacy_and_medical_value)
                        );
                    }

                    // for qualified high deductible plans, it has to use  
                    // Pharmacy: Capital Prime
                    // Build: Attribute: Information: Deductible - Dynamics 365 = Yes; 
                    // and Build: Attribute: Information: Deductible Integration Accumulation - Dynamics 365 | Build: Option Set: Information: Capital Prime Accumulation Integration - Dynamics 365 = 20 - Combined Pharmacy and Medical 
                    // and Build: Attribute: Information: Out of Pocket - Dynamics 365 = Yes; 
                    // and Build: Attribute: Information: Out of Pocket Integration Accumulation - Dynamics 365 |  Build: Option Set: Information: Capital Prime Accumulation Integration - Dynamics 365 = 20 - Combined Pharmacy and Medical
                    let hasIncorrectCapitalPrimeAccumulators = false;
                    if (capitalBenefit &&
                        !capitalBenefit.deactivated &&
                        capitalBenefit.status.value !== FAM_EBenefitStatus.Cancelled
                    ) {

                        const [capitalPrimeDeductible,] = getBooleanByMasterAttributeId(capitalBenefit, $matt_$capital_prime_$bcbs_deductible_cp_id);
                        const [capitalPrimeDeductibleIntegrationAccumulation,] = getOptionSetValueByMasterAttributeId(capitalBenefit, $matt_$capital_prime_$bcbs_dedintegrationaccum_cp_id);
                        const [capitalPrimeOutOfPocket,] = getBooleanByMasterAttributeId(capitalBenefit, $matt_$capital_prime_$bcbs_oop_cp_id);
                        const [capitalPrimeOutOfPocketIntegrationAccumulation,] = getOptionSetValueByMasterAttributeId(capitalBenefit, $matt_$capital_prime_$bcbs_oopintegrationaccum_cp_id);

                        hasIncorrectCapitalPrimeAccumulators = (
                            capitalPrimeDeductible !== true ||
                            (capitalPrimeDeductible === true &&
                                capitalPrimeDeductibleIntegrationAccumulation !== $oset_$capital_prime_accumulation_integration_$combined_pharmacy_and_medical_value) ||
                            capitalPrimeOutOfPocket !== true ||
                            (capitalPrimeOutOfPocket === true &&
                                capitalPrimeOutOfPocketIntegrationAccumulation !== $oset_$capital_prime_accumulation_integration_$combined_pharmacy_and_medical_value)
                        );
                    }

                    if (
                        hasIncorrectOptumAccumulators ||
                        hasIncorrectFloridaPrimeAccumulators ||
                        hasIncorrectCapitalPrimeAccumulators
                    ) {
                        dataValidations.push({
                            title: 'Review Pharmacy accumulators to ensure integration is accurately entered.',
                            type: EValidationSeverity.warn,
                            description: `Plan: ${eachPlan.name}\nMedical Benefit: ${medicalBenefit.name}\nPharmacy Benefit: ${optumBenefit?.name ?? floridaBenefit?.name ?? capitalBenefit?.name ?? 'N/A'}`,
                        });
                    }
                }
            }
        }

        // feesAndPremiumsRef unique name check
        if (rules.checkUniqueName)
            if (stateJson.plans.some(eachTest => eachTest.name === eachPlan.name && eachTest !== eachPlan)) {
                uniqueEntityNameValidations.push({
                    title: `Plan (${eachPlan.name}) does not have a unique name.`,
                    type: EValidationSeverity.error,
                    description: `Plan id: ${eachPlan.id}`,
                });
            }

        // feesAndPremiumsRef reference check
        if (rules.checkRef)
            if (eachPlan.feesAndPremiumsRef) {
                const matchingFNP = feesAndPremiumLookup[eachPlan?.feesAndPremiumsRef?.id];

                if (!matchingFNP)
                    refValidations.push({
                        title: `Plan (${eachPlan.name}) is referencing an invalid Fees And Premium (${eachPlan?.feesAndPremiumsRef?.name ?? 'N/A'}).`,
                        type: EValidationSeverity.error,
                        description: `Plan id: ${eachPlan.id}\r\nFees and Premium id${eachPlan?.feesAndPremiumsRef.id}`,
                    });

                if (matchingFNP && matchingFNP.deactivated)
                    refValidations.push({
                        title: `Plan (${eachPlan.name}) is referencing a deactivated Fees And Premium (${eachPlan?.feesAndPremiumsRef?.name ?? 'N/A'}).`,
                        type: EValidationSeverity.error,
                        description: `Plan id: ${eachPlan.id}\r\nFees and Premium id:${eachPlan?.feesAndPremiumsRef.id}`,
                    });
            }


        // does it have FNP reference?
        if (rules.checkCoverage)
            if (!eachPlan.deactivated)
                if (eachPlan.feesAndPremiumsRef && fieldMap) {

                    const coverageMap = CoverageMapping.map(t => {

                        const tt: ICoverageMapper = {
                            ...t,
                            plan: eachPlan,
                            plan_fieldValue: null,
                        };

                        const field = fieldMap![t.plan_attributeId];
                        if (field && field.values && field.values.length > 0) {
                            const fieldValue = (field.values[0].value as FAM_IBooleanValue);

                            if (fieldValue)
                                tt.plan_fieldValue = fieldValue;
                        }

                        return tt;
                    });

                    plansCoverageFields[eachPlan.id] = coverageMap;
                }

        // benefit reference check
        if (eachPlan.benefitRefs && eachPlan.benefitRefs.length > 0) {

            eachPlan.benefitRefs.forEach(eachPlanBenefitRef => {

                const foundBenefit = benefitLookup[eachPlanBenefitRef.id];

                if (rules.checkRef) {

                    if (!foundBenefit) {
                        refValidations.push({
                            title: `Plan (${eachPlan.name}) is referencing an invalid Benefit (${eachPlanBenefitRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `Plan id: ${eachPlan.id}\r\nBenefit id${eachPlanBenefitRef?.id}`,
                        });
                    }

                    if (foundBenefit && foundBenefit.deactivated) {
                        refValidations.push({
                            title: `Plan (${eachPlan.name}) is referencing a deactivated Benefit (${foundBenefit?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `Plan id: ${eachPlan.id}\nBenefit id${foundBenefit?.id}`,
                        });
                    }
                }

                if (!eachPlan.deactivated)
                    if (rules.checkGrandfathered) {

                        // GF/NGF Benefit to Plan Mismatch
                        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/341091
                        if (foundBenefit && !foundBenefit.deactivated) {
                            if (!!eachPlan.grandFathered?.value && !!foundBenefit.grandFathered?.value) {
                                if (foundBenefit.bcbs_isgrandfatherenabled)
                                    if (foundBenefit.grandFathered?.value !== eachPlan.grandFathered?.value) {

                                        grandFatherValidations.push({
                                            title: `Plan (${eachPlan.name}) and Benefit (${foundBenefit?.name ?? 'N/A'}) GF/NGF miss match detected.`,
                                            type: EValidationSeverity.error,
                                            description: `Plan GF/NGF: ${eachPlan?.grandFathered?.name}\nBenefit GF/NGF: ${foundBenefit?.grandFathered?.name}`,
                                            // onRenderDescription: OnRenderDescriptionValidationItem(
                                            //     <Stack horizontal tokens={{ childrenGap: '15px' }}>
                                            //         <PlanCard
                                            //             key={eachPlan.id}
                                            //             plan={eachPlan}
                                            //             onClick={() => history?.push(AppLinkTo(state, { id: eachPlan.id, type: 'plan' }))}
                                            //             state={state}
                                            //         />
                                            //         <BenefitCard
                                            //             key={foundBenefit.id}
                                            //             benefit={foundBenefit}
                                            //             state={state}
                                            //             mode={EBenefitCardFunction.display}
                                            //             onClick={() => { history?.push(AppLinkTo(state, { id: foundBenefit.id, type: 'benefit', parent: { id: eachPlan.id, type: 'plan' } })); }}
                                            //         />
                                            //     </Stack>
                                            // ),
                                        });
                                    }

                            }

                        }
                    }

            });
        }

        // Billing Only Plan validation - Apply validation edits to ensure proper Plan building
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/373830
        if (rules.checkBillingOnlyPlan)
            if (!eachPlan.deactivated) {

                const billingOnly = eachPlan.billingOnlyPlan;
                const hasBenefit = eachPlan.benefitRefs.length > 0;
                const hasGroupNumber = (r_pl_gns[eachPlan.id]?.length ?? 0) > 0;
                const hasFeesAndPremium = eachPlan.feesAndPremiumsRef
                    ? feesAndPremiumLookup[eachPlan.feesAndPremiumsRef.id]
                    : null;

                if (!billingOnly && !hasBenefit) {
                    billingOnlyPlanValidations.push({
                        title: `A non-billing Plan (${eachPlan.name}) has no Benefits.`,
                        type: EValidationSeverity.error,
                    });
                }

                if (!billingOnly && !hasGroupNumber) {
                    billingOnlyPlanValidations.push({
                        title: `A non-billing Plan (${eachPlan.name}) has no Group Numbers.`,
                        type: EValidationSeverity.warn,
                    });
                }

                if (billingOnly && hasBenefit) {
                    billingOnlyPlanValidations.push({
                        title: `A Billing Only Plan (${eachPlan.name}) has benefits.`,
                        type: EValidationSeverity.error,
                    });
                }

                if (billingOnly && !hasGroupNumber) {
                    billingOnlyPlanValidations.push({
                        title: `A Billing Only Plan (${eachPlan.name}) has no Group Numbers.`,
                        type: EValidationSeverity.error,
                    });
                }


                if (!ignoreFNPAndPlanAssociationCheck)
                    if (!billingOnly && !hasFeesAndPremium) {
                        billingOnlyPlanValidations.push({
                            title: `Plan (${eachPlan.name}) has no Fees And Premium associated.`,
                            type: EValidationSeverity.error,
                            description: `All non-billing Plans should have a related Fees and Premium.`,
                        });
                    }
            }

        // Validation Edit: Telehealth should match in medical and telehealth benefit
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/594875
        if (rules.checkData)
            if (!eachPlan.deactivated)
                if (
                    planWithBenefits.Telehealth &&
                    planWithBenefits.Medical &&
                    !planWithBenefits.Telehealth.deactivated &&
                    !planWithBenefits.Medical.deactivated
                ) {
                    const medical_getFieldsMemo = getFieldsMemoByEntity(planWithBenefits.Medical);
                    const telehealth_getFieldsMemo = getFieldsMemoByEntity(planWithBenefits.Telehealth);

                    // Telehealth : Medical, Optionset
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=e8366214-9a62-ec11-8f8f-002248040f87
                    const medical_bcbs_telehealthid_field = medical_getFieldsMemo()[$matt_$medical_$bcbs_telehealthid_id]?.[0]?.field?.values;

                    // Telehealth : Telehealth, Optionset
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=e25c1e1f-a042-ee11-bdf5-000d3a3bec48
                    const telehealth_bcbs_telehealthid_field = telehealth_getFieldsMemo()[$matt_$telehealth_$bcbs_telehealthid_id]?.[0]?.field?.values;

                    if (medical_bcbs_telehealthid_field[0].value?.type === 'entity' && telehealth_bcbs_telehealthid_field[0].value?.type === 'entity') {
                        const medical_telehealthValue = medical_bcbs_telehealthid_field[0].value.name;
                        const telehealth_telehealthValue = telehealth_bcbs_telehealthid_field[0].value.name;

                        if (medical_telehealthValue !== telehealth_telehealthValue) {
                            dataValidations.push({
                                title: `Plan (${eachPlan.name}) has different Telehealth values.`,
                                type: EValidationSeverity.error,
                                description: `Telehealth Plan (${eachPlan.name})\nMedical Benefit (${planWithBenefits.Medical.name}) - Value: ${medical_telehealthValue}\nTelehealth Benefit (${planWithBenefits.Telehealth.name}) - Value: ${telehealth_telehealthValue}`,
                            });
                        }
                    }
                }

        // Validation Edit - Group Cancellation - FSA and HRA Cancellation Reminder
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/617968
        // When a Group Configuration is being cancelled and there is an Active HRA or Active FSA Benefit related to an active Plan where the Benefit is NOT cancelled
        // present a validation error that reads "The FSA or HRA Benefit(s) must be cancelled and runout information entered before the Cancellation can be processed."
        if (rules.checkData) {

            if (isCancellationConfiguration)
                if (!eachPlan.deactivated) {

                    // HRA Validation
                    {
                        const ben = planWithBenefits.HRA;
                        if (ben && !ben.deactivated &&
                            ben.status.value !== FAM_EBenefitStatus.Cancelled) {
                            dataValidations.push({
                                title: `The ${ben.bcbs_name} (${ben.name}) benefit must be cancelled.`,
                                type: EValidationSeverity.error,
                                description: `Plan (${eachPlan.name}) has an active HRA Benefit (${ben.name}/${ben.status.name}) that is not cancelled.\nThe ${ben.bcbs_name} benefit must be cancelled and runout information entered before the Cancellation can be processed.`,
                            });
                        }
                    }

                    // FSA Validation
                    {
                        const ben = planWithBenefits.FSA;
                        if (ben && !ben.deactivated &&
                            ben.status.value !== FAM_EBenefitStatus.Cancelled) {
                            dataValidations.push({
                                title: `The ${ben.bcbs_name} (${ben.name}) benefit must be cancelled.`,
                                type: EValidationSeverity.error,
                                description: `Plan (${eachPlan.name}) has an active HRA Benefit (${ben.name}/${ben.status.name}) that is not cancelled.\nThe ${ben.bcbs_name} benefit must be cancelled and runout information entered before the Cancellation can be processed.`,
                            });
                        }
                    }

                }
        }




    });

    // Benefits
    // -------------------------------------------------------
    stateJson.benefits.forEach(eachBenefit => {

        // map to array of master attributes, first element in array being the visible one and memoize so we only run it once if we need to access it multiple times
        const getFieldsMemo = getFieldsMemoByEntity(eachBenefit);

        const getTiersMemo = Memoize(() => {
            return ArrayToLookupByPredicate(eachBenefit.tiers ?? [], t => t.id);
        })

        if (rules.checkUniqueName)
            if (stateJson.benefits.some(eachTest => eachTest.name === eachBenefit.name && eachTest !== eachBenefit)) {
                uniqueEntityNameValidations.push({
                    title: `Benefit (${eachBenefit.name}) does not have a unique name.`,
                    type: EValidationSeverity.error,
                    description: `Benefit id: ${eachBenefit.id}`,
                });
            }

        if (rules.checkData) {
            if (!eachBenefit.deactivated) {
                // medical benefit ?
                if (eachBenefit.bcbs_config_categoryid === stateConfig.cache.map_bcbs_config_category_named['Medical'].bcbs_config_categoryid) {

                    // ABA Therapy pays at:
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=2652723e-f777-ec11-8d21-000d3a5b9199
                    // * This has tier split
                    // * This has no pcp/specialist split
                    const bcbs_abatherapypayat = getFieldsMemo()[$matt_$medical_$bcbs_abatherapypayat_id]?.[0]?.field?.values;

                    bcbs_abatherapypayat.forEach(eachValue => {
                        if (eachValue.tierRef?.id) {
                            const tier = getTiersMemo()[eachValue.tierRef.id];

                            // bcbs_copaycoinoption
                            // Not Covered, id = f01e8a49-d1c0-df11-992a-000c29d4337a

                            // if users enter "Not Covered" in Tiers 1-3 and INN 
                            if (eachValue.value?.type === 'entity' && eachValue?.value?.id === 'f01e8a49-d1c0-df11-992a-000c29d4337a') {
                                if (tier.name !== "Out of Network")
                                    dataValidations.push({
                                        title: `"Not Covered" is not a valid selection for ABA Network Benefits.`,
                                        type: EValidationSeverity.error,
                                        description: `ABA therapy has been reinstated as a tiered attribute. If you select "Not Covered" for Tiers or INN, the system will prevent submission.\n\nBenefit: ${eachBenefit.name}\nTier: ${tier?.name}`,
                                        // onRenderDescription: () => {
                                        //     return <Stack tokens={{ childrenGap: '10px' }} styles={{ root: { padding: '5px', paddingTop: '20px' } }}>
                                        //         <Stack.Item>
                                        //             <Stack>
                                        //                 <Text>
                                        //                     ABA therapy has been reinstated as a tiered attribute. If you select "Not Covered" for Tiers or INN, the system will prevent submission.
                                        //                 </Text>
                                        //             </Stack>
                                        //         </Stack.Item>
                                        //         <Stack.Item>
                                        //             <Text variant="small">
                                        //                 {`Benefit (${eachBenefit.name}) > ABA Therapy Pay At (${tier?.name})`}
                                        //             </Text>
                                        //         </Stack.Item>
                                        //         {/* <Stack.Item align="end">
                                        //         <Stack horizontal tokens={{ childrenGap: '10px' }}>
                                        //             <Text variant="small">
                                        //                 <Link onClick={() => {

                                        //                     // Example Route :
                                        //                     // groupConfiguration/52047332-605e-ef11-bfe3-000d3a9d4961/benefit/9d22cb36-dbda-4976-880f-4056093ff07f/tab/a2df6811-0c43-ec11-8c60-000d3a5b8f01/section/e385526f-7f75-ec11-8941-000d3a3527e6/field/?navigation=complete
                                        //                     let route = AppLinkTo(state,
                                        //                         {
                                        //                             id: "8e0316f6-7378-ec11-8d21-000d3a34c462", type: 'field',
                                        //                             parent: {
                                        //                                 id: "e385526f-7f75-ec11-8941-000d3a3527e6", type: 'section',
                                        //                                 parent: {
                                        //                                     id: "a2df6811-0c43-ec11-8c60-000d3a5b8f01", type: 'tab',
                                        //                                     parent: {
                                        //                                         id: eachBenefit.id, type: 'benefit'
                                        //                                     }
                                        //                                 }
                                        //                             }
                                        //                         },
                                        //                     );

                                        //                     route = route + '?navigation=pending';
                                        //                     history?.push(route)
                                        //                 }}>
                                        //                     Benefit ({eachBenefit.name})
                                        //                 </Link>
                                        //             </Text>
                                        //         </Stack>
                                        //     </Stack.Item> */}
                                        //     </Stack>
                                        // }
                                    });
                            }

                        }
                    });
                }
            }
        }

        // Validation Edit - Display a hard edit when the Subgroup or Benefit Cancellation Effective Date does not match the Effective Date of the Configuration
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/502867
        if (rules.checkData) {
            if (!eachBenefit.deactivated) {
                if (eachBenefit.status.value === FAM_EBenefitStatus.Cancelled) {
                    // individual benefits get their own cancellation field and also users can add custom benefits for cancellation
                    for (const key in stateConfig.cache.map_bcbs_config_masterattribute_cancellations) {
                        const bcbs_cancellation = getFieldsMemo()[key];
                        if (bcbs_cancellation) {

                            const bcbs_cancellation_value = bcbs_cancellation[0].field.values?.[0].value?.type === 'date'
                                ? bcbs_cancellation[0].field.values?.[0].value
                                : undefined;

                            const jsonEffectiveDate = stateJson.effectiveDate?.value;
                            const benefitEffectiveDate = bcbs_cancellation_value?.value;

                            const benefitEffectiveDateValue = benefitEffectiveDate
                                ? formatDate(parseDate(benefitEffectiveDate, 'yyyy-MM-ddThh:mm:ssZ as local'), 'local:MM/dd/yyyy')
                                : "(blank)";

                            const snapshotEffectiveDateValue = jsonEffectiveDate
                                ? formatDate(parseDate(jsonEffectiveDate, 'yyyy-MM-ddThh:mm:ssZ as local'), 'local:MM/dd/yyyy')
                                : "(blank)";

                            if (jsonEffectiveDate !== benefitEffectiveDate) {
                                dataValidations.push({
                                    title: `The Benefit Cancellation Effective Date must match the Group Configuration Effective Date.`,
                                    type: EValidationSeverity.error,
                                    description: `Group Configuration Effective Date: ${snapshotEffectiveDateValue}\nBenefit: ${eachBenefit.name}\nCancellation Effective Date: ${benefitEffectiveDateValue}`,
                                });
                            }

                        }
                    }
                }
            }
        }

        // When Drugs are covered under = Carve-Out Vendor and Does this group have Integrated Drug? Yes and both Integrate of deductible? (Carve Out Only) and Integrate on Out of Pocket? (Carve Out Only) = No
        // Present a Validation Edit that reads:
        // Integrate on Deductible and/or Integrate on OOP must be selected.
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/732579
        if (rules.checkData) {

            if (!eachBenefit.deactivated) {
                // medical benefit ?
                if (eachBenefit.bcbs_config_categoryid === stateConfig.cache.map_bcbs_config_category_named['Medical'].bcbs_config_categoryid) {
                    if (eachBenefit.status.value !== FAM_EBenefitStatus.Cancelled) {

                        // Med Drug: Drugs are covered under
                        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=d991d4e1-c24b-ec11-8f8e-000d3a3340f2
                        // bcbs_epo_drgugsarecoveredunder
                        // Option Set: BCBS Rx(100000000), BCBS Rx - Capital Prime(5), BCBS Rx - Florida Prime(4), Carve-Out Vendor(3)
                        const [drugsCoveredUnder,] = getOptionSetGuidByMasterAttribute(eachBenefit, $matt_$medical_$bcbs_epo_drgugsarecoveredunder_id);

                        // Does this group have Integrated Drug?    
                        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=dd91d4e1-c24b-ec11-8f8e-000d3a3340f2
                        // bcbs_epo_integrateddrigcaremark
                        // boolean
                        const [integratedDrug,] = getBooleanByMasterAttributeId(eachBenefit, $matt_$medical_$bcbs_epo_integrateddrigcaremark_id);

                        // Integrate on deductible?
                        // bcbs_integrateondeductible
                        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=e191d4e1-c24b-ec11-8f8e-000d3a3340f2
                        // boolean
                        const [integrateOnDeductible,] = getBooleanByMasterAttributeId(eachBenefit, $matt_$medical_$bcbs_integrateondeductible_id);

                        // Integrate on Out of Pocket?
                        // bcbs_integrateonoutofpocket
                        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=e391d4e1-c24b-ec11-8f8e-000d3a3340f2
                        // boolean
                        const [integrateOnOutOfPocket,] = getBooleanByMasterAttributeId(eachBenefit, $matt_$medical_$bcbs_integrateonoutofpocket_id);

                        if (
                            drugsCoveredUnder === $oset_$medical_drug_pbm_$carve_out_vendor_id &&
                            integratedDrug === true &&
                            integrateOnDeductible === false &&
                            integrateOnOutOfPocket === false
                        ) {
                            dataValidations.push({
                                title: 'Integrate on Deductible and/or Integrate on OOP must be selected.',
                                type: EValidationSeverity.error,
                                description: `Medical Benefit: ${eachBenefit.name}`,
                            });
                        }

                    }
                }
            }
        }

        // Benefit - Attribute Sets
        // -------------------------------------------------------
        eachBenefit.attributeSets.forEach(eachAttributeSet => {

            const getAttFieldsMemo = getFieldsMemoByEntity(eachAttributeSet);

            // Validation Edit - Some elements are sharing an identifier within the same context
            // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/382827
            // if (checkUniqueName)
            //     if (stateDataJson.attributeSets.some(eachTest => eachTest.name === eachAS.name && eachTest !== eachAS)) {
            //         uniqueValidations.push({
            //             title: `AttributeSet (${eachAS.name}) on GroupConfiguration does not have a unique name.`,
            //             type: EValidationSeverity.warn,
            //             description: `AttributeSet id: ${eachAS.id}`,
            //         });
            //     }

            // ITS Facility/ITS Professional
            // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/504010
            if (rules.checkRequiredFields)
                if (!eachBenefit.deactivated && !eachAttributeSet.deactivated)

                    // Custom Network / Attribute Set
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=4cd7c5a7-d590-ec11-b400-0022480a93ed
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=f1646443-d590-ec11-b400-0022480a93ed
                    if (eachAttributeSet.attributeSetRef.id === $matt_$medical_$bcbs_attributeset_customnetwork_id) {

                        // Network Filing Method
                        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=29130b39-8bb3-ed11-83fe-000d3a305861
                        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=125833f0-8ab3-ed11-83fe-000d3a305861
                        const bcbs_networkfilingmethod = getAttFieldsMemo()[$matt_$medical_$bcbs_networkfilingmethod_id];

                        const bcbs_networkfilingmethod_value = bcbs_networkfilingmethod[0].field.values?.[0].value?.type === 'entity'
                            ? bcbs_networkfilingmethod[0].field.values?.[0].value
                            : undefined;

                        // Question) is it enabled for ITS ?
                        // ITS : id = c5ce2ee2-8bb3-ed11-83fe-000d3a305861
                        // ITS Spin-Off: id = 7e28d81e-8cb3-ed11-83fe-000d3a305861
                        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_optionsetitem&id=c5ce2ee2-8bb3-ed11-83fe-000d3a305861
                        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_optionsetitem&id=7e28d81e-8cb3-ed11-83fe-000d3a305861
                        // Update: disabled for ITS Spin-Off, see https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/555682
                        const isITS = bcbs_networkfilingmethod_value?.id === $oset_$network_filing_method_$its_id; //

                        if (isITS) {

                            // ITS Facility Network Pricing
                            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=13b3b141-040f-ef11-9f89-6045bdeb64f8
                            const bcbs_itsfacilitynetworkpricing = getAttFieldsMemo()[$matt_$medical_$bcbs_itsfacilitynetworkpricing_id];
                            const bcbs_itsfacilitynetworkpricing_value = bcbs_itsfacilitynetworkpricing[0].field.values?.[0].value?.type === 'entity'
                                ? bcbs_itsfacilitynetworkpricing[0].field.values?.[0].value
                                : null;

                            // ITS Professional Network Pricing
                            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=686ea39f-050f-ef11-9f89-6045bdeb64f8
                            const bcbs_itsprofessionalnetworkpricing = getAttFieldsMemo()[$matt_$medical_$bcbs_itsprofessionalnetworkpricing_id];
                            const bcbs_itsprofessionalnetworkpricing_value = bcbs_itsprofessionalnetworkpricing[0].field.values?.[0].value?.type === 'entity'
                                ? bcbs_itsprofessionalnetworkpricing[0].field.values?.[0].value
                                : null;

                            // checked both facility and professional, they are sharing the same option set item
                            // Rule : ITS Facility and ITS Professional are both set to NOT APPLICABLE
                            // One of ITS Facility and ITS Professional is set to NOT APPLICABLE and the other is Null
                            // Both are Null

                            // name: not applicable - id: 5f770a51-050f-ef11-9f89-6045bdeb64f8
                            // null/blank

                            // Question) either null or both not applicable ?
                            if (
                                (bcbs_itsprofessionalnetworkpricing_value?.id === $oset_$its_network_pricing_$not_applicable_id
                                    && bcbs_itsfacilitynetworkpricing_value?.id === $oset_$its_network_pricing_$not_applicable_id)
                                || (bcbs_itsprofessionalnetworkpricing_value === null
                                    || bcbs_itsfacilitynetworkpricing_value === null)
                            ) {
                                requiredFieldsValidations.push({
                                    title: `Conflicting or Incomplete ITS Fields.`,
                                    type: EValidationSeverity.error,
                                    description: `'ITS Facility' and 'ITS Professional' cannot both be marked as 'Not Applicable' in the same Attribute Set or left unselected\nPlease review and correct the entries.\nBenefit (${eachBenefit.name}) > Custom Networks (${eachAttributeSet.name})`,
                                });
                            }
                        }
                    }
        });

        eachBenefit.nonStandards.forEach(eachNonstandard => {
            // nothing to do for now
            return;
        });

    });

    // Group Structure : CES Number
    // -------------------------------------------------------
    const cesNumberLookup: Record<string, FAM_ICESNumber> = {};
    stateJson.groupStructure.cesNumbers.forEach(eachCESNumber => {

        if (rules.checkUniqueName) {
            if (!eachCESNumber.deactivated)
                if (eachCESNumber.cesNumber) {
                    const testCES = cesNumberLookup[eachCESNumber.cesNumber!];
                    if (testCES)
                        uniqueEntityNameValidations.push({
                            title: `CES Number(${eachCESNumber.cesNumber}) is not unique.`,
                            type: EValidationSeverity.error,
                            description: `This CES number has been defined multiple times in Group Structure\nYou may need to manage tool to merge the CES Number.`,
                        });
                    else
                        cesNumberLookup[eachCESNumber.cesNumber!] = eachCESNumber;
                }
        }
    });

    // Group Structure : Group Number
    // -------------------------------------------------------
    const groupNumbers_dataValidations_retireNa: IValidationMessage[] = [];
    const groupNumbers_dataValidations_sameEffectiveDates: IValidationMessage[] = [];

    stateJson.groupStructure.groupNumbers.forEach((eachGroupNumber) => {

        // map to array of master attributes, first element in array being the visible one and memoize so we only run it once if we need to access it multiple times
        const getFieldsMemo = getFieldsMemoByEntity(eachGroupNumber);

        // CES Number
        if (!eachGroupNumber.deactivated) {

            if (rules.checkRef) {
                if (eachGroupNumber.cesNumberRef) {
                    const foundCES = cesLookup[eachGroupNumber.cesNumberRef.id];

                    if (!foundCES) {
                        refGroupNumberCESValidation.push({
                            title: `GroupNumber (${eachGroupNumber.groupNumber}) is referencing an invalid CES Client Number(${eachGroupNumber.cesNumberRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `GroupNumber id: ${eachGroupNumber.id}\nCES Client Number id: ${eachGroupNumber.cesNumberRef?.id}`,
                        });
                    }

                    if (foundCES && foundCES.deactivated) {
                        refGroupNumberCESValidation.push({
                            title: `GroupNumber (${eachGroupNumber.groupNumber}) is referencing a deactivated CES Client Number(${eachGroupNumber.cesNumberRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `GroupNumber id: ${eachGroupNumber.id}\nCES Client Number id: ${eachGroupNumber.cesNumberRef?.id}`,
                        });
                    }
                }
            }

            // Plan
            if (rules.checkRef) {
                if (eachGroupNumber.planRef) {
                    const foundPlan = planLookup[eachGroupNumber.planRef.id];

                    if (!foundPlan) {
                        refGroupNumberPlanValidation.push({
                            title: `GroupNumber (${eachGroupNumber.groupNumber}) is referencing an invalid Plan (${eachGroupNumber.planRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `GroupNumber id: ${eachGroupNumber.id}\nPlan id: ${eachGroupNumber.planRef?.id}`,
                        });
                    }

                    if (foundPlan && foundPlan.deactivated) {
                        refGroupNumberPlanValidation.push({
                            title: `GroupNumber (${eachGroupNumber.groupNumber}) is referencing a deactivated Plan (${eachGroupNumber.planRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `GroupNumber id: ${eachGroupNumber.id}\nPlan id: ${eachGroupNumber.planRef?.id}`,
                        });
                    }
                }
            }

            // StopLoss
            if (rules.checkRef) {
                if (eachGroupNumber.stopLossRef) {
                    const foundStopLoss = stopLossLookup[eachGroupNumber.stopLossRef.id];

                    if (!foundStopLoss) {
                        refGroupNumberStopLossValidation.push({
                            title: `GroupNumber (${eachGroupNumber.groupNumber}) is referencing an invalid StopLoss(${eachGroupNumber.stopLossRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `GroupNumber id: ${eachGroupNumber.id}\nStopLoss id: ${eachGroupNumber.planRef?.id}`,
                        });
                    }

                    if (foundStopLoss && foundStopLoss.deactivated) {
                        refGroupNumberStopLossValidation.push({
                            title: `GroupNumber (${eachGroupNumber.groupNumber}) is referencing a deactivated StopLoss(${eachGroupNumber.stopLossRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `GroupNumber id: ${eachGroupNumber.id}\nStopLoss id: ${eachGroupNumber.stopLossRef?.id}`,
                        });
                    }
                }
            }

            // Accounts Receivable
            if (rules.checkRef) {
                if (eachGroupNumber.accountsReceivableRef) {
                    const foundAccountsReceivableRef = accountsReceivableLookup[eachGroupNumber.accountsReceivableRef.id];

                    if (!foundAccountsReceivableRef) {
                        refGroupNumberAccountsReceivableValidation.push({
                            title: `GroupNumber (${eachGroupNumber.groupNumber}) is referencing an invalid Accounts Receivable(${eachGroupNumber.accountsReceivableRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `GroupNumber id: ${eachGroupNumber.id}\nAccounts Receivable id: ${eachGroupNumber.planRef?.id}`,
                        });
                    }

                    if (foundAccountsReceivableRef && foundAccountsReceivableRef.deactivated) {
                        refGroupNumberAccountsReceivableValidation.push({
                            title: `GroupNumber (${eachGroupNumber.groupNumber}) is referencing a deactivated Accounts Receivable(${eachGroupNumber.accountsReceivableRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `GroupNumber id: ${eachGroupNumber.id}\nAccounts Receivable id: ${eachGroupNumber.accountsReceivableRef?.id}`,
                        });
                    }
                }
            }

            // TODO this might need to be moved
            if (rules.checkUniqueName) {
                if (eachGroupNumber.groupNumber) {
                    const testGN = groupNumbersLookup[eachGroupNumber.groupNumber!];
                    if (testGN && testGN.length > 1)
                        uniqueEntityNameValidations.push({
                            title: `Group Number(${eachGroupNumber.groupNumber}) is not unique.`,
                            type: EValidationSeverity.error,
                            description: `This Group Number has been used multiple times in Group Structure\nYou may need to change group number or deactivate one(s) that are no longer active.`,
                        });
                }

            }

            if (!eachGroupNumber.groupNumber)
                refValidations.push({
                    title: `There is an instance of an invalid Group structure / Group Number without value.`,
                    type: EValidationSeverity.error,
                });


            if (rules.checkData) {

                // Validation Edit - Display a hard edit when the Subgroup or Benefit Cancellation Effective Date does not match the Effective Date of the Configuration
                // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/502867
                if (eachGroupNumber?.status?.value === FAM_EBenefitStatus.Cancelled) {

                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=7086c361-d18d-ec11-b400-0022480a93ed
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=d67c1bc6-d18d-ec11-b400-0022480a93ed
                    const bcbs_cancellation = getFieldsMemo()[$matt_$group_number_$bcbs_cancellationeffectivedate_id];

                    // 598407 - The reconciliation flag for validation edit
                    // the reconciliation flag should allow a Subgroup or Benefit Effective Date and/or Subgroup or Benefit Cancellation date to differ from the Effective Date of the Configuration.  Otherwise we would not be able to reconcile changes appropriately.
                    if (bcbs_cancellation && !(stateJson.reconciliation?.value ?? false)) {

                        const bcbs_cancellation_value = bcbs_cancellation[0].field.values?.[0].value?.type === 'date'
                            ? bcbs_cancellation[0].field.values?.[0].value
                            : undefined;

                        const jsonEffectiveDate = stateJson.effectiveDate?.value;
                        const gnCancellationEffectiveDate = bcbs_cancellation_value?.value;

                        const gnEffectiveDateValue = gnCancellationEffectiveDate
                            ? formatDate(parseDate(gnCancellationEffectiveDate, 'yyyy-MM-ddThh:mm:ssZ as local'), 'local:MM/dd/yyyy')
                            : "(blank)";

                        const snapshotEffectiveDateValue = jsonEffectiveDate
                            ? formatDate(parseDate(jsonEffectiveDate, 'yyyy-MM-ddThh:mm:ssZ as local'), 'local:MM/dd/yyyy')
                            : "(blank)";

                        if (jsonEffectiveDate !== gnCancellationEffectiveDate) {
                            dataValidations.push({
                                title: `The Group Number (${eachGroupNumber.groupNumber}) Cancellation Effective Date must match the Group Configuration Effective Date.`,
                                type: EValidationSeverity.warn,
                                description: `Group Configuration Effective Date: ${snapshotEffectiveDateValue}\nCancellation Effective Date: ${gnEffectiveDateValue}`,
                            });
                        }
                    }
                }

                // // Validation Edit - Subgroup - Remove Subgroup Effective Date must match group configuration effective date needs to be a soft edit
                // // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/678885

                // // Validation Edit - Subgroup - Subgroup Effective Date must match group configuration effective date needs to be a soft edit
                // // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/662512
                // // Validation Edit - Subgroup - Subgroup Effective Date must match group configuration Effective date (warning if it doenst);
                // {

                //     // Effective Date
                //     // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=7a86c361-d18d-ec11-b400-0022480a93ed
                //     const bcbs_effectivedate = getFieldsMemo()['7a86c361-d18d-ec11-b400-0022480a93ed'];

                //     const bcbs_effectivedate_value = bcbs_effectivedate[0].field.values?.[0].value?.type === 'date'
                //         ? bcbs_effectivedate[0].field.values?.[0].value
                //         : undefined;

                //     const jsonEffectiveDate = stateJson.effectiveDate?.value;
                //     const gnEffectiveDate = bcbs_effectivedate_value?.value;

                //     const gnEffectiveDateValue = gnEffectiveDate
                //         ? formatDate(parseDate(gnEffectiveDate, 'yyyy-MM-ddThh:mm:ssZ as local'), 'local:MM/dd/yyyy')
                //         : "(blank)";

                //     const snapshotEffectiveDateValue = jsonEffectiveDate
                //         ? formatDate(parseDate(jsonEffectiveDate, 'yyyy-MM-ddThh:mm:ssZ as local'), 'local:MM/dd/yyyy')
                //         : "(blank)";

                //     if (jsonEffectiveDate !== gnEffectiveDate) {
                //         groupNumbers_dataValidations_sameEffectiveDates.push({
                //             title: `Effective Date for (${eachGroupNumber.groupNumber}) does not match Configuration's Effective Date.`,
                //             type: EValidationSeverity.warn,
                //             description: `Group Number: ${eachGroupNumber.groupNumber}\nGroup Configuration Effective Date: ${snapshotEffectiveDateValue}\nEffective Date: ${gnEffectiveDateValue}`,
                //         });
                //     }

                // }

                // Validation Edit - Present hard edit to compare Subgroup Type to Group Size Indicator (Retiree)
                // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/672360
                // Marketing should get a hard edit when the group structure contains a Subgroup Type of Retiree and the Retiree Subgroup, Group Size Indicator = N/A
                // 679707 Validation Edit - Hard edit to compare Subgroup Type to Group Size Indicator (Retiree) only on certain change types
                if (!isAdminChange) {
                    // Subgroup Type
                    // https://bcbsonline.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=6c86c361-d18d-ec11-b400-0022480a93ed
                    const subgroupType_mat = getFieldsMemo()[$matt_$group_number_$bcbs_subgrouptype_id];

                    const subgroupType = subgroupType_mat[0].field.values?.[0].value?.type === 'entity'
                        ? subgroupType_mat[0].field.values?.[0].value
                        : undefined;

                    // Option 1:
                    // * this is expired but to keep backward compatibility we will check for it
                    // Retirees
                    // 100,000,000
                    // https://bcbsonline.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_optionsetitem&id=1954698e-d08d-ec11-b400-0022480a93ed

                    // Option 2:
                    // Retiree
                    // Value: 4
                    // https://bcbsonline.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_optionsetitem&id=1354698e-d08d-ec11-b400-0022480a93ed
                    if (subgroupType?.id === $oset_$subgroup_type_$retiree_id || subgroupType?.id === $oset_$subgroup_type_$retirees_id) {

                        // Group Size Indicator (Retiree Subgroups)
                        // https://bcbsonline.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=242efbb7-be5d-ec11-8f8f-000d3a5a0d43

                        const getGroupConfigFieldsMemo = getFieldsMemoByEntity(stateJson)

                        const groupSizeIndicator_mat = getGroupConfigFieldsMemo()[$matt_$group_configuration_$bcbs_aso_groupsizeindicatorretireesubgroups_id];
                        const groupSizeIndicator = groupSizeIndicator_mat[0].field.values?.[0].value?.type === 'entity'
                            ? groupSizeIndicator_mat[0].field.values?.[0].value
                            : undefined;

                        // N/A
                        // Value: 4
                        // https://bcbsonline.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_optionsetitem&id=e02c2605-bc5d-ec11-8f8f-000d3a5a062b
                        if (groupSizeIndicator?.id === $oset_$group_configuration_size_indicator_retiree_subgroups_$n_a_id) {
                            groupNumbers_dataValidations_retireNa.push({
                                title: `Group Size Indicator (Retiree) is invalid for Group Number (${eachGroupNumber.groupNumber}).`,
                                type: EValidationSeverity.error,
                            });
                        }

                    }
                }

            }
        }
    });

    if (groupNumbers_dataValidations_retireNa.length > 0) {
        dataValidations.push({
            title: `Group Size Indicator (Retiree) is invalid.`,
            type: EValidationSeverity.error,
            inner: groupNumbers_dataValidations_retireNa,
        });
    }

    if (groupNumbers_dataValidations_sameEffectiveDates.length > 0) {
        dataValidations.push({
            title: `Some Group Number(s) Effective does not match the Configuration's Effective Date.`,
            type: EValidationSeverity.warn,
            inner: groupNumbers_dataValidations_sameEffectiveDates,
        });
    }


    // Group Structure : Departments 
    // --------------------------------------------------------
    stateJson.groupStructure.departments.forEach(eachDepartment => {

        // CES Number
        if (rules.checkRef) {
            if (eachDepartment.cesNumberRef) {
                const foundCES = cesLookup[eachDepartment.cesNumberRef.id];

                if (!eachDepartment.deactivated)
                    if (!foundCES) {
                        refDepartmentCESValidation.push({
                            title: `Department(${eachDepartment.name}) is referencing an invalid CES Client Number(${eachDepartment.cesNumberRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `Department id: ${eachDepartment.id}\nCES Client Number id: ${eachDepartment.cesNumberRef?.id}`,
                        });
                    }

                if (!eachDepartment.deactivated)
                    if (foundCES && foundCES.deactivated) {
                        refDepartmentCESValidation.push({
                            title: `Department(${eachDepartment.name}) is referencing a deactivated CES Client Number(${eachDepartment.cesNumberRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `Department id: ${eachDepartment.id}\nCES Client Number id: ${eachDepartment.cesNumberRef?.id}`,
                        });
                    }
            }
        }

    });

    // Prevent submissions for more than one distinct client number for a given plan
    // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/305176
    if (rules.checkPlanGroupStructure)
        for (const [planRefId, planCes] of Object.entries(r_pl_ces_gn)) {
            if (Object.keys(planCes).length > 1) {
                const cesNumberList = [] as string[];

                // TODO build html table
                for (const [cesNumberRefid, groupNumber] of Object.entries(planCes)) {
                    // cesnumber is not deactivated
                    // group number is not deactivated
                    if (!cesLookup[cesNumberRefid].deactivated && !groupNumber.deactivated && groupNumber?.status?.value !== FAM_EBenefitStatus.Cancelled) {
                        cesNumberList.push(`Group Number: ${groupNumber.groupNumber}, CES Client Number: ${groupNumber?.cesNumberRef?.name}`);
                    }
                }

                const plan = planLookup[planRefId];
                if (!plan.deactivated && cesNumberList.length > 1)
                    planGroupStructureValidations.push({
                        title: `Plan (${plan.name}) is associated to more than one CES Client Number.`,
                        description: 'There is more than one Client Number associated to subgroups related to a singular Plan. A Plan should not have more than one Client Number for the associated subgroups.\n'
                            + cesNumberList.join('\n'),
                        type: EValidationSeverity.error,
                    });
            }
        }

    // Group Structure : Group Number : Second Part
    // -------------------------------------------------------
    if (refGroupNumberPlanValidation.length > 0) {
        refValidations.push({
            title: `Some Group Number(s) are referencing an invalid / deactivated Plan.`,
            type: EValidationSeverity.error,
            inner: refGroupNumberPlanValidation
        });
    }

    if (refGroupNumberCESValidation.length > 0) {
        refValidations.push({
            title: `Some Group Number(s) are referencing an invalid / deactivated CES Number.`,
            type: EValidationSeverity.error,
            inner: refGroupNumberCESValidation
        });
    }

    if (refGroupNumberStopLossValidation.length > 0) {
        refValidations.push({
            title: `Some Group Number(s) are referencing an invalid / deactivated StopLoss.`,
            type: EValidationSeverity.error,
            inner: refGroupNumberStopLossValidation
        });
    }

    if (refGroupNumberAccountsReceivableValidation.length > 0) {
        refValidations.push({
            title: `Some Group Number(s) are referencing an invalid / deactivated Accounts Receivable.`,
            type: EValidationSeverity.error,
            inner: refGroupNumberAccountsReceivableValidation
        });
    }

    if (refDepartmentCESValidation.length > 0) {
        refValidations.push({
            title: `Some Department(s) are referencing an invalid / deactivated CES Number.`,
            type: EValidationSeverity.error,
            inner: refDepartmentCESValidation
        });
    }

    // Fees And Premiums
    // -------------------------------------------------------
    // SBC - Produce "Warning" when generating a SBC where there are no Subgroups associated to the Plan
    // prevent a submission if plan is not marked as a non-billing and has no associated group number
    // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/322504
    // rolling back this for now, until a decision is made
    // if (checkBillingOnlyPlan)
    //     stateDataJson?.plans?.forEach(eachPlan => {
    //         if (!eachPlan.deactivated)
    //             if (!eachPlan.billingOnlyPlan) {
    //                 const anyGroupNumber = planGroupNumberLookup[eachPlan.id];

    //                 if (!anyGroupNumber) {
    //                     billingOnlyPlanValidations.push({
    //                         title: `A Non - Billing Plan (${ eachPlan.name }) is missing a related Group Number.`,
    //                         description: `All active non - billing plans must have at least one related Group Number.\nIf this is a billing only plan, considering identifying under plan properties.`,
    //                         severity: EValidationSeverity.error,
    //                     });
    //                 }
    //             }
    //     });
    stateJson.feesAndPremiums.forEach((eachFeesAndPremium: FAM_IFeesAndPremiums) => {

        // TODO update code to use getFieldsMemoByEntity
        const getFieldsMemo = getFieldsMemoByEntity(eachFeesAndPremium);

        // lets only build this if needed for the context
        let fieldMap: Record<string, FAM_IFlexibleField> | null = null;

        if (!fieldMap)
            if (rules.checkCoverage)
                fieldMap = ArrayToLookupByPredicate(eachFeesAndPremium.fields, t => t.configRef.id);

        if (rules.checkUniqueName)
            if (stateJson.feesAndPremiums.some(eachTest => eachTest.name === eachFeesAndPremium.name && eachTest !== eachFeesAndPremium)) {
                uniqueEntityNameValidations.push({
                    title: `Fees And Premium(${eachFeesAndPremium.name}) does not have a unique name.`,
                    type: EValidationSeverity.error,
                    description: `Fees And Premium id: ${eachFeesAndPremium.id}`,
                });
            }

        if (rules.checkCoverage)
            if (!eachFeesAndPremium.deactivated) {
                const coverageMap = CoverageMapping.map(t => {
                    const tt: ICoverageMapper = {
                        ...t,
                        fnp: eachFeesAndPremium,
                        fnp_fieldValue: null,
                    };

                    const field = fieldMap![t.fnp_attributeId];

                    if (field && field.values && field.values.length > 0) {
                        const fieldValue = (field.values[0].value as FAM_IBooleanValue);

                        if (fieldValue)
                            tt.fnp_fieldValue = fieldValue;
                    }

                    return tt;
                });

                feesAndPremiumsCoverages[eachFeesAndPremium.id] = coverageMap;
            }


        if (rules.checkData) {
            if (!eachFeesAndPremium.deactivated) {
                const fnp = r_fnp_pl[eachFeesAndPremium.id];

                // Validation Edit - Hard Edit when Fees and Premiums are present but not related to a Plan.
                // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/550985
                // Reps are unable to submit (DEC) when there is a Fee and Premium record present but is not related to a Plan.
                if (!ignoreFNPAndPlanAssociationCheck)
                    if ((fnp?.length ?? 0) === 0) {
                        dataValidations.push({
                            title: `Fees And Premium (${eachFeesAndPremium.name}) is not associated with a plan.`,
                            type: EValidationSeverity.error,
                        });

                    }
            }
        }

        // fee config:
        const attributeSetFee = stateConfig.cache.map_bcbs_config_attribute[$att_$fees_and_premiums_$bcbs_attributeset_fee_id];

        let vmEachFee: IValidationMessage | null = null;

        // Fees and Premium - Attribute Sets
        // -------------------------------------------------------
        eachFeesAndPremium.attributeSets.forEach(eachAttributeSet => {

            const eachAttributeSetFieldsMemo = getFieldsMemoByEntity(eachAttributeSet);

            // TODO use getFieldsMemoByEntity, how ever the method works based on master attribute id, so we need to convert the code below to use attribute id
            let attributeSetFieldMap: Record<string, FAM_IFlexibleField> | null = null;

            if (!attributeSetFieldMap)
                if (rules.checkCoverage)
                    attributeSetFieldMap = ArrayToLookupByPredicate(eachAttributeSet.fields, t => t.configRef.id);

            // 382827
            // if (checkUniqueName)
            //     if (eachFP.attributeSets.some(eachTest => eachTest.name === eachAS.name && eachTest !== eachAS)) {
            //         uniqueValidations.push({
            //             title: `Attributeset(${ eachAS.name }) on Fees And Premium(${ eachFP.name }) does not have a unique name.`,
            //             type: EValidationSeverity.warn,
            //             description: `Attributeset id: ${ eachAS.id }\r\nFees And Premium id: ${ eachFP.id }`,
            //         });
            //     }

            // Fees And Premium and Fee Detail Line coverage match
            // Coverage Tier rates identified on Fees MUST match the coverage tier settings on Fees and Premium 
            // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/260416
            if (rules.checkCoverage) {
                if (!eachFeesAndPremium.deactivated && !eachAttributeSet.deactivated)
                    if (eachAttributeSet.attributeSetRef.id === attributeSetFee._bcbs_config_masterattributeid_value) {
                        // validating on fee attribute set
                        if (attributeSetFieldMap) {

                            const bccAdminField = attributeSetFieldMap[bcbs_config_attributeid_BCCAdmin];

                            const feeTypeField = attributeSetFieldMap[bcbs_config_attributeid_FeeType];

                            const bccAdminFieldValue = bccAdminField?.values?.[0]?.value as FAM_IEntityReferenceValue;
                            const feeTypeFieldValue = feeTypeField?.values?.[0]?.value as FAM_IEntityReferenceValue;

                            if (feeTypeFieldValue && feeTypeFieldValue.id === pepmFeeType.id)
                                if (bccAdminFieldValue) {
                                    // lets find the category selected in bcc admin
                                    const bccAdmin = stateConfig.cache.map_bcbs_bccadmin[bccAdminFieldValue.id];

                                    if (!bccAdmin._bcbs_categoryid_value)
                                        throw new Error("bad data");

                                    const category = stateConfig.cache.map_bcbs_config_category[bccAdmin._bcbs_categoryid_value!];

                                    if (!category)
                                        throw new Error("bad data");

                                    const coverageMappingByCategory = CoverageMapping.filter(q => q.fnp_fee_bccAdminCategory === category.bcbs_name);

                                    const coverageMappingLocal = coverageMappingByCategory.map(t => {
                                        const tt = { ...t };
                                        // Fees and Premium
                                        {
                                            const field = fieldMap![t.fnp_attributeId];

                                            tt.fnp_attributeId = field.configRef.id;

                                            if (field && field.values && field.values.length > 0) {
                                                const fieldValue = (field.values[0].value as FAM_IBooleanValue);

                                                if (fieldValue)
                                                    tt.fnp_fieldValue = fieldValue;
                                            }
                                        }

                                        // Fees and Premium - Attribute Set
                                        {
                                            const field = attributeSetFieldMap![t.fnp_fee_attributeId];
                                            const value = field?.values?.[0]?.value as FAM_INumberValue;

                                            tt.fnp_fee = eachAttributeSet;
                                            tt.fnp_fee_attributeId = field.configRef.id;
                                            tt.fnp_fee_fieldValue = value;
                                        }

                                        return tt;
                                    });

                                    let vm: IValidationMessage | null = null;

                                    coverageMappingLocal.forEach(eachX => {

                                        let badCoverage = false;

                                        // if coverage is set, but there is no value
                                        badCoverage = badCoverage || eachX.fnp_fieldValue?.value === true && (!eachX.fnp_fee_fieldValue?.value && eachX.fnp_fee_fieldValue?.value !== 0);

                                        // it coverage is not set, but there is a value 
                                        badCoverage = badCoverage || (!eachX.fnp_fieldValue?.value && (!!eachX.fnp_fee_fieldValue?.value || eachX.fnp_fee_fieldValue?.value === 0));

                                        if (badCoverage) {

                                            const attribute_fnp_fee = stateConfig.cache.map_bcbs_config_attribute[eachX.fnp_fee_attributeId];
                                            const attribute_fnp = stateConfig.cache.map_bcbs_config_attribute[eachX.fnp_attributeId];

                                            if (!vmEachFee) {

                                                vmEachFee = {
                                                    title: `Coverage mismatch on Fees And Premium(${eachFeesAndPremium.name}) and related Fees.`,
                                                    type: EValidationSeverity.error,
                                                    inner: []
                                                }

                                                coverageValidations.push(vmEachFee);
                                            }

                                            if (!vm) {

                                                vm = {
                                                    title: `Fees And Premium(${eachFeesAndPremium.name}) and Fee(${eachAttributeSet.name}) coverage does not match.`,
                                                    type: EValidationSeverity.error,
                                                    inner: []
                                                }

                                                vmEachFee.inner?.push(vm);
                                            }

                                            vm.inner?.push({
                                                title: `Field(${attribute_fnp_fee.bcbs_name}) does not match the specified coverage.`,
                                                type: EValidationSeverity.error,
                                                description: `Attributeset: ${eachAttributeSet.name}\nField: ${attribute_fnp_fee.bcbs_name}\nValue: ${eachX.fnp_fee_fieldValue?.value}\n\nFees And Premium: ${eachFeesAndPremium.name}) \nField: ${attribute_fnp.bcbs_name} \nValue: ${eachX.fnp_fieldValue?.value} `,
                                                inner: []
                                            })
                                        }
                                    })
                                }
                        }
                    }
            }



            // Onsite
            // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/611600
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=ad2e2ea8-4f00-f011-bae2-6045bdef1703
            {
                const onsite = eachAttributeSetFieldsMemo()[$matt_$fees_and_premiums_$bcbs_perscriptonsite_id]

                const onsite_field = onsite?.[0]?.field;

                if (onsite_field) {
                    if ((onsite_field.visibility ?? 0) === 0) {
                        if (onsite_field.values?.length === 0 || !onsite_field.values[0].value) {
                            requiredFieldsValidations.push({
                                title: `Onsite field is not set.`,
                                type: EValidationSeverity.error,
                                description: `Onsite field is required to be set on Fees And Premium Attribute Set.\nOnsite field is not set on Fees And Premium(${eachFeesAndPremium.name}) Attribute Set(${eachAttributeSet.name}).`,
                            });
                        }
                    }
                }
            }

            // Guarantee Start Date
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=ff15559e-d978-ec11-8d21-000d3a34c462
            {
                const guaranteeStartDate = eachAttributeSetFieldsMemo()[$matt_$fees_and_premiums_$bcbs_guaranteestartdate_id];

                const guaranteeStartDate_field = guaranteeStartDate?.[0]?.field;

                if (guaranteeStartDate_field) {
                    if ((guaranteeStartDate_field.visibility ?? 0) === 0) {
                        if (guaranteeStartDate_field.values?.length === 0 || !guaranteeStartDate_field.values[0].value) {
                            requiredFieldsValidations.push({
                                title: `Guarantee Start Date field is not set.`,
                                type: EValidationSeverity.error,
                                description: `Guarantee Start Date field is required to be set on Fees And Premium Attribute Set.\nGuarantee Start Date field is not set on Fees And Premium(${eachFeesAndPremium.name}) Attribute Set(${eachAttributeSet.name}).`,
                            });
                        }
                    }
                }

                // Fee Guarantee End Date is > Configuration Effective Date
                // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/611600
                if (guaranteeStartDate_field) {

                    const effectiveDate = parseDate(stateJson!.effectiveDate!.value, 'yyyy-MM-ddThh:mm:ssZ as local');

                    const guaranteeStartDate_field_value = guaranteeStartDate_field.values?.[0]?.value as FAM_IDateValue;

                    if (guaranteeStartDate_field_value) {
                        const startDate = parseDate(guaranteeStartDate_field_value.value, 'yyyy-MM-ddThh:mm:ssZ as local');

                        if (startDate > effectiveDate) {
                            dataValidations.push({
                                title: `Guarantee Start Date is greater than Configuration Effective Date.`,
                                type: EValidationSeverity.error,
                                description: `Fees And Premium(${eachFeesAndPremium.name}) Attribute Set(${eachAttributeSet.name})\nGuarantee Start Date: ${formatDate(startDate, 'local:MM/dd/yyyy')}\nConfiguration Effective Date: ${formatDate(effectiveDate, 'local:MM/dd/yyyy')}`,
                            });
                        }

                    }
                }

            }

            // Guarantee End Date
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=0f16559e-d978-ec11-8d21-000d3a34c462
            {
                const guaranteeEndDate = eachAttributeSetFieldsMemo()[$matt_$fees_and_premiums_$bcbs_guaranteeenddate_id];

                const guaranteeEndDate_field = guaranteeEndDate?.[0]?.field;

                if (guaranteeEndDate_field) {
                    if ((guaranteeEndDate_field.visibility ?? 0) === 0) {
                        if (guaranteeEndDate_field.values?.length === 0 || !guaranteeEndDate_field.values[0].value) {
                            requiredFieldsValidations.push({
                                title: `Guarantee End Date field is not set.`,
                                type: EValidationSeverity.error,
                                description: `Guarantee End Date field is required to be set on Fees And Premium Attribute Set.\nGuarantee End Date field is not set on Fees And Premium(${eachFeesAndPremium.name}) Attribute Set(${eachAttributeSet.name}).`,
                            });
                        }
                    }
                }

            }


        });
    });

    // Plan and Fees And Premium coverage match
    // 260416 - Coverage Tier settings on Plan MUST match the coverage tiers settings on Fees and Premium
    // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/260416
    if (rules.checkCoverage) {
        for (const key in plansCoverageFields) {
            const planCoverage = plansCoverageFields[key];

            let planError: IValidationMessage | null = null;

            planCoverage.forEach((eachPlanCoverage, index) => {

                const fnpCoverage = feesAndPremiumsCoverages[eachPlanCoverage.plan?.feesAndPremiumsRef?.id!]
                const eachFnpCoverage = fnpCoverage[index];

                const attributePlan = stateConfig.cache.map_bcbs_config_attribute[eachPlanCoverage.plan_attributeId];
                const attributeFee = stateConfig.cache.map_bcbs_config_attribute[eachFnpCoverage.fnp_attributeId];

                if (eachPlanCoverage.plan_fieldValue?.value !== eachFnpCoverage.fnp_fieldValue?.value) {

                    if (!planError)
                        planError = {
                            title: `Plan (${eachPlanCoverage.plan?.name}) and related Fees And Premium(${eachFnpCoverage.fnp?.name}) coverage does not match.`,
                            type: EValidationSeverity.error,
                            description: `Coverage tiers for plan and related Fees And Premium setup must exactly match.`,
                            inner: []
                        }

                    planError.inner?.push({
                        title: `Coverage mismatch on field(${attributePlan.bcbs_name}).`,
                        type: EValidationSeverity.error,
                        description: `Plan Coverage Field: ${attributePlan.bcbs_name} \nValue: ${eachPlanCoverage.plan_fieldValue?.value} \n\nFee Coverage Field: ${attributeFee.bcbs_name} \nValue: ${eachFnpCoverage.fnp_fieldValue?.value} `,
                    });
                }
            });

            if (planError)
                coverageValidations.push(planError);
        }
    }

    // Account Receivable / Claims AR ---
    // -------------------------------------------------------
    stateJson.claimsARs.forEach(eachAccountsReceivable => {

        const eachAccountsReceivableFieldsMemo = getFieldsMemoByEntity(eachAccountsReceivable);

        if (rules.checkUniqueName)
            if (stateJson.claimsARs.some(eachTest => eachTest.name === eachAccountsReceivable.name && eachTest !== eachAccountsReceivable)) {
                uniqueEntityNameValidations.push({
                    title: `Accounts Receivable(${eachAccountsReceivable.name}) does not have a unique name.`,
                    type: EValidationSeverity.error,
                    description: `Accounts Receivable id: ${eachAccountsReceivable.id} `,
                });
            }

        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/375442
        if (checkRelatedToGroupNumber)
            if (!eachAccountsReceivable.deactivated)
                if (!r_ar_gns[eachAccountsReceivable.id]) {
                    relatedToGroupNumberValidations.push({
                        title: `Accounts Receivable(${eachAccountsReceivable.name}) is not related to any Group Numbers.`,
                        type: EValidationSeverity.warn,
                        description: `Accounts Receivable id: ${eachAccountsReceivable.id} `,
                    });
                }


        // Fees and Premiums - Shared Savings - New fields in Shared Savings Attribute Set
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/516907
        if (rules.checkData) {
            const accountsReceivableRelations = r_ar_fnp[eachAccountsReceivable.id];

            // AR CE Cap Amount (master)
            // Claims Edit Cap Amount
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=3e347f02-8d4a-ef11-a317-000d3a17460e
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=5fde294b-8d4a-ef11-a317-000d3a17460e
            const bcbs_cecapamount_ar = eachAccountsReceivableFieldsMemo()[$matt_$accounts_receivable_$bcbs_cecapamount_ar_id];
            const bcbs_cecapamount_ar_value = bcbs_cecapamount_ar?.[0]?.field?.values?.[0]?.value?.type === 'number'
                ? (bcbs_cecapamount_ar?.[0]?.field?.values?.[0]?.value)
                : null;

            // AutoCalculate clears the AR Cap Amount if any related Claims Edits instance has Bill to Group = No.
            // Defer cap validation messages until all related instances have been checked.
            // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/734199
            let hasBillToGroupSetToFalse = false;
            const capAmountValidations: IValidationMessage[] = [];

            accountsReceivableRelations?.forEach(eachRelation => {

                // any of relationship is deactivated, skip
                if (eachRelation.plan.deactivated || eachRelation.accountsReceivable.deactivated || eachRelation.feesAndPremium.deactivated)
                    return;

                // new cap amount field on AR doesn`t exist, skip
                if (!bcbs_cecapamount_ar)
                    return;

                // we need to compare each individual shared savings attribute set with accounts receivable, to make sure its compliant
                eachRelation.feesAndPremium.attributeSets.forEach(eachAttributeSet => {

                    // Fees And Premium - Shared Savings - Attribute Set Fields:
                    const getEachAttributeSetFieldsMemo = getFieldsMemoByEntity(eachAttributeSet);

                    if (eachRelation.feesAndPremium.deactivated)
                        return;

                    if (eachAttributeSet.deactivated)
                        return;

                    // Shared Savings / Attribute Set
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=296bac98-575e-ee11-be6f-000d3a3bec27
                    // not shared saving attribute set? skip
                    if (eachAttributeSet.attributeSetRef.id === $matt_$fees_and_premiums_$bcbs_sharedsavings_id) {

                        // Shared Savings Category
                        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=2b6bac98-575e-ee11-be6f-000d3a3bec27
                        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=7b606da3-585e-ee11-be6f-000d3a3bec27
                        const bcbs_sharedsavings_categorycode = getEachAttributeSetFieldsMemo()[$matt_$fees_and_premiums_$bcbs_sharedsavings_categorycode_id];
                        const bcbs_sharedsavings_categorycode_value = bcbs_sharedsavings_categorycode?.[0].field?.values?.[0]?.value?.type === 'entity'
                            ? bcbs_sharedsavings_categorycode[0].field.values[0].value
                            : null;

                        // Claims Edits ?
                        // "entity/bcbs_config_optionsetitem/Claims Edits/af7e9d03-565e-ee11-be71-000d3a3be219"
                        // shared saving claim type is not set to claims edit? skip
                        if (bcbs_sharedsavings_categorycode_value?.id === $oset_$shared_savings_category_$claims_edits_id) {

                            // Cap Amount
                            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=356bac98-575e-ee11-be6f-000d3a3bec27
                            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=8b606da3-585e-ee11-be6f-000d3a3bec27
                            const bcbs_sharedsavings_capamount = getEachAttributeSetFieldsMemo()[$matt_$fees_and_premiums_$bcbs_sharedsavings_capamount_id];
                            const bcbs_sharedsavings_capamount_value = bcbs_sharedsavings_capamount?.[0].field?.values?.[0]?.value?.type === 'number'
                                ? bcbs_sharedsavings_capamount[0].field.values[0].value
                                : null;

                            // IPRP - CE Bill Group
                            const billToGroup = getEachAttributeSetFieldsMemo()[$matt_$fees_and_premiums_$bcbs_iprpcebillgroup_fp_id];
                            const billToGroupValue = getExactValue<FAM_IBooleanValue>(
                                getEachAttributeSetFieldsMemo(),
                                $matt_$fees_and_premiums_$bcbs_iprpcebillgroup_fp_id,
                                null, null, null);

                            hasBillToGroupSetToFalse = hasBillToGroupSetToFalse || billToGroupValue?.value === false;

                            // if no AR cap amount
                            // if no FNP-SharedSaving-ClaimEdit cap amount - if no shared savings claim edit cap amount
                            // if bad cap amount - different shared savings claim edit cap amount compared to AR cap amount
                            if (validateClaimsCap)
                                if (!bcbs_cecapamount_ar_value || !bcbs_sharedsavings_capamount_value || bcbs_cecapamount_ar_value?.value !== bcbs_sharedsavings_capamount_value?.value) {
                                    capAmountValidations.push({
                                        title: `Claims Edit Cap Amounts must match.`,
                                        type: EValidationSeverity.error,
                                        description: `A discrepancy has been detected in the Claims Edit Cap amounts on Accounts Receivable, as well as the associated Fees And Premiums, Shared Savings attributeset, based on the Plan/Group Number relationship.\n\nPlan: ${eachRelation.plan.name}\nGroup Number: ${eachRelation.lastGroupNumber.groupNumber}\nAccounts Receivable: ${eachAccountsReceivable.name} \nFees And Premium: ${eachRelation.feesAndPremium.name}\nShared Savings: ${eachAttributeSet.name}\nAccounts Receivable Cap Amount: ${bcbs_cecapamount_ar_value?.value} \nShared Savings Cap Amount: ${bcbs_sharedsavings_capamount_value?.value}`,
                                    });
                                }
                        }
                    }

                });

            });

            // if there is no Bill to Group = No, then push cap amount validations (all related instances have Bill to Group = Yes)
            if (!hasBillToGroupSetToFalse)
                dataValidations.push(...capAmountValidations);
        }

        eachAccountsReceivable.attributeSets.forEach(eachAttributeSet => {
            // nothing to do for now
            return;
        });

    });

    // Stop Loss ---
    // -------------------------------------------------------
    stateJson.stopLoss.forEach(eachStopLoss => {

        // const getFieldsMemo = getFieldsMemoByEntity(eachAttributeSet);

        if (rules.checkUniqueName)
            if (stateJson.stopLoss.some(eachTest => eachTest.name === eachStopLoss.name && eachTest !== eachStopLoss)) {
                uniqueEntityNameValidations.push({
                    title: `StopLoss(${eachStopLoss.name} / ${eachStopLoss.id}) does not have a unique name.`,
                    type: EValidationSeverity.error,
                    description: `StopLoss id: ${eachStopLoss.id} `,
                });
            }

        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/375442
        if (checkRelatedToGroupNumber) {
            if (!eachStopLoss.deactivated && !r_sl_gns[eachStopLoss.id]) {
                relatedToGroupNumberValidations.push({
                    title: `Stop Loss (${eachStopLoss.name}) is not related to any Group Numbers.`,
                    type: EValidationSeverity.warn,
                    description: `Stop Loss id: ${eachStopLoss.id}`,
                });
            }
        }

        eachStopLoss.attributeSets.forEach(eachAttributeSet => {
            // const eachAttributeSetFieldsMemo = getFieldsMemoByEntity(eachAttributeSet);

            // nothing to do for now
            return;
        });

    });

    // Other ---
    // -------------------------------------------------------
    // Not latest release message should only display on Group Configurations which are not yet UWRC
    // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/390788
    if (rules.checkRelease)
        if (stateConfig.bcbs_config_release?.statuscode !== IXrmOptions_bcbs_config_release.statuscode["Published(2)"].value)
            if (!isPostUWRC) {
                // we could have used : !state.data.snapshot.bcbs_underwritingreviewcompletedate MUal mentioned this would not have been comprehensive enough
                releaseValidations.push({
                    title: `Configuration is not using the latest published release.`,
                    description: `Present configuration does not encompass the latest update.\nTo ensure optimal functionality, it is recommended to select the Save > Update Release option to apply the configuration updates.\nPlease be advised that selecting this option will result in copying the current configuration into a new configuration on the latest published release. The current configuration will then be deactivated.`,
                    type: context === EDataValidationContext.ESaveSubmit ? EValidationSeverity.error : EValidationSeverity.info,
                });
            }

    // if submitting, we need to run the validation : 
    // we have not validated and this type of save requires validation:
    if (saveInstructions.saveType === ESaveType.ESubmit) {

        let forceUnderwritingReview = false;

        let isDataEntryComplete = false;

        let isAnotherPendingUW: IXrmTypes_bcbs_groupconfigurationsnapshot[] | null = null;

        let isCancellation = false;

        // Cache
        getSBCsNotReadyMemoizedAsync();

        isDataEntryComplete = true;

        saveInstructions.onSaveStatusScreen = true;
        saveInstructions.onPostSaveSetViewOnly = true;

        // first lets mark as data entry complete!
        saveInstructions.onSaveSetStatusCode = IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Data Entry Complete(808900000)'].value;

        // when I submit a record that is MNIL, it is going to "MNIL Data Entry Complete" instead of "Data Entry Complete"
        // const changeTypeValue = props.state.data.data.changeType?.value;
        // changeTypeValue === bcbs_groupconfigurationsnapshot.bcbs_changetypecode["MNIL  Benefit Change Continuation(808900007)"].value ||
        // changeTypeValue === bcbs_groupconfigurationsnapshot.bcbs_changetypecode["MNIL  Initial Setup Continuation(808900005)"].value ||
        // changeTypeValue === bcbs_groupconfigurationsnapshot.bcbs_changetypecode["MNIL  Renewal Continuation(808900008)"].value
        if (state?.data?.json?.MNIL?.value) {
            saveInstructions.onSaveSetStatusCode = IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['MNIL Data Entry Complete(808900003)'].value;
        }

        // if its admin/psa change, then we  by pass data entry complete stage
        if (
            state.data.json.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["PSA Change(808900012)"].value ||
            state.data.json.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Administrative Change(808900003)"].value
        ) {

            isDataEntryComplete = false
            forceUnderwritingReview = true;

            saveInstructions.onSaveStatusScreen = true;
            saveInstructions.onPostSaveSetViewOnly = true;
            saveInstructions.onSaveSetStatusCode = IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Underwriting Review Complete(2)'].value;
        }

        // if its admin/psa change, then we  by pass data entry complete stage
        if (saveInstructions.onSaveBypassUnderwritingTaskGeneration) {

            isDataEntryComplete = false
            forceUnderwritingReview = true;

            saveInstructions.onSaveStatusScreen = true;
            saveInstructions.onPostSaveSetViewOnly = true;
            saveInstructions.onSaveSetStatusCode = IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Underwriting Review Complete(2)'].value;
        }

        // any other snapshots with same effective date exists that is in almost final stage?
        // lets mark this one as pending
        if (isDataEntryComplete || forceUnderwritingReview) {

            // TODO optimize this
            const snapshotsMemoized = await getSnapshotsMemoizedAsync();

            const anyUW = snapshotsMemoized.filter(eachSnapshot =>
                (
                    eachSnapshot.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Data Entry Complete(808900000)'].value ||
                    eachSnapshot.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Corrections Pending(808900005)'].value
                )
                && new Date(eachSnapshot?.bcbs_effectivedate ?? 1).getTime() === new Date(state.data?.json?.effectiveDate?.value ?? 0).getTime()
            );

            if (anyUW.length > 1)
                isAnotherPendingUW = anyUW;

            if (anyUW.length === 1 && anyUW[0].bcbs_groupconfigurationsnapshotid !== state.data.snapshot.bcbs_groupconfigurationsnapshotid)
                isAnotherPendingUW = anyUW;

            if (isAnotherPendingUW) {
                saveInstructions.onSaveSetStatusCode = IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Pending Underwriting(808900009)'].value;

                forceUnderwritingReview = false;
                isDataEntryComplete = false;
            }
        }

        if (saveInstructions.onSaveSetStatusCode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Data Entry Complete(808900000)'].value)
            if (state.data.json.changeType?.value !== IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode['Initial Setup(808900002)'].value) {

                // get me best snapshot comparable to this
                const compareCandidate = compareUnderWritingReviewToWithoutDispatch(state, state.data.snapshot);

                // if no default left snapshot is identified
                // no parent is set?
                if (!compareCandidate && !state.data.snapshot._bcbs_uwconfirmedparentid_value) {
                    // Pending Power User Review
                    saveInstructions.onSaveSetStatusCode = IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode["Pending Power User Review(808900015)"].value;
                }

                if (compareCandidate)
                    if (!state.data.snapshot._bcbs_uwconfirmedparentid_value) {
                        saveInstructions.onSaveChangeUWConfirmedParentId = compareCandidate.bcbs_groupconfigurationsnapshotid
                    }
            }

        // Cancellation Updates
        if (state?.data?.json?.status?.value === FAM_EGroupConfigurationStatus['Cancellation in Progress']) {
            isCancellation = true;

            saveInstructions.onSaveStatusScreen = true;
            saveInstructions.onPostSaveSetViewOnly = true;
            saveInstructions.onSaveSetStatusCode = IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Cancelled(808900011)'].value;;
        }

        if (state?.data?.json?.status?.value === FAM_EGroupConfigurationStatus['Transferred to Other LOB in Progress']) {
            isCancellation = true;

            saveInstructions.onSaveStatusScreen = true;
            saveInstructions.onPostSaveSetViewOnly = true;
            saveInstructions.onSaveSetStatusCode = IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Transferred to Other LOB(808900012)'].value;;
        }

        if (isCancellation) {
            isDataEntryComplete = false;
            isAnotherPendingUW = null;
            forceUnderwritingReview = false;
        }

        // Validation
        // BUG 319455 - Group Configuration - Opportunity Validation
        if (
            state.data.snapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Initial Setup(808900002)"].value ||
            state.data.snapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["MNIL  Renewal Continuation(808900008)"].value ||
            state.data.snapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Benefit Renewal(808900010)"].value ||
            state.data.snapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Financial Renewal(808900011)"].value ||
            state.data.snapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Comprehensive Renewal(808900001)"].value
        ) {
            let opportunityMemoized = await getOpportunityMemoizedAsync();

            if (opportunityMemoized && opportunityMemoized.estimatedclosedate && state.data.json.effectiveDate?.value) {
                const opportunityEffectiveDate = new Date(opportunityMemoized!.estimatedclosedate);
                const jsonEffectiveDate = new Date(state.data.json.effectiveDate?.value);

                const delta = opportunityEffectiveDate.getTime() - jsonEffectiveDate.getTime();

                if (delta !== 0) {
                    const t: IValidationMessage = {
                        title: `Effective Date does not match the Effective Date of the related Opportunity.`,
                        onRenderDescription: OnRenderDescriptionValidationItem(
                            <div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td style={{ textAlign: 'right' }}>Opportunity</td>
                                            <td><LinkTo opportunity={opportunityMemoized} /></td>
                                        </tr>
                                        <tr>
                                            <td style={{ textAlign: 'right' }}>Group Configuration Effective Date</td>
                                            <td>{formatDate(jsonEffectiveDate, 'en-US-ET:yyyy-MM-ddThh:mm:ssZ as local')}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ textAlign: 'right' }}>Related Opportunity Effective Date</td>
                                            <td>{formatDate(opportunityEffectiveDate, 'en-US-ET:yyyy-MM-ddThh:mm:ssZ as local')}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        ),
                        type: EValidationSeverity.error
                    };

                    // show warning for Financial Renewal
                    // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/424549
                    if (state.data.snapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Financial Renewal(808900011)"].value)
                        t.type = EValidationSeverity.warn

                    otherValidations.push(t);
                }
            }
        }

        // 319457 - Initial Setup and Renewal Validation
        //  if there exists a Group Configuration with the same Change Type and Effective Date and status is Data Entry Complete, Corrections Pending, Gold Standard, or Retired,
        if (
            state.data.snapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Initial Setup(808900002)"].value ||
            state.data.snapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["MNIL  Renewal Continuation(808900008)"].value ||
            state.data.snapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Benefit Renewal(808900010)"].value ||
            state.data.snapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Financial Renewal(808900011)"].value ||
            state.data.snapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Comprehensive Renewal(808900001)"].value
        ) {

            const snapshotsMemoized = await getSnapshotsMemoizedAsync();

            const matchingSnapshots = snapshotsMemoized.filter(t => {

                // same snapshot as currently loaded one?
                if (t.bcbs_groupconfigurationsnapshotid === state.data.snapshot.bcbs_groupconfigurationsnapshotid)
                    return false;

                // Condition - not a Data Entry Complete/Gold Standard/Retired
                const status =
                    t.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Data Entry Complete(808900000)'].value ||
                    t.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Gold Standard(808900006)'].value ||
                    t.statuscode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Retired(808900001)'].value;

                if (!status)
                    return false;

                // Condition - effective date miss match
                // TODO this needs to use the json effective date, not the snapshot one state.data.snapshot > state.data.json.effectiveDate?.value with coverts
                const effectiveDateMatch = t.bcbs_effectivedate === state.data.snapshot.bcbs_effectivedate;
                if (!effectiveDateMatch)
                    return false;

                // Condition - Change Type
                let expectedChangeType = false;
                if (state.data.snapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Initial Setup(808900002)"].value) {

                    expectedChangeType =
                        t.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode['Initial Setup(808900002)'].value;

                } else if (state.data.snapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Benefit Renewal(808900010)"].value) {

                    expectedChangeType =
                        t.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode['Benefit Renewal(808900010)'].value ||
                        t.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode['Comprehensive Renewal(808900001)'].value;

                } else if (state.data.snapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Financial Renewal(808900011)"].value) {

                    expectedChangeType =
                        t.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode['Financial Renewal(808900011)'].value ||
                        t.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode['Comprehensive Renewal(808900001)'].value;

                } else if (state.data.snapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Comprehensive Renewal(808900001)"].value) {

                    expectedChangeType = t.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode['Benefit Renewal(808900010)'].value ||
                        t.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode['Financial Renewal(808900011)'].value ||
                        t.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode['Comprehensive Renewal(808900001)'].value;

                }

                if (expectedChangeType)
                    return true;

                return false;
            });

            if (matchingSnapshots && matchingSnapshots.length > 0) {
                matchingSnapshots.forEach(snapshot => {
                    otherValidations.push({
                        title: `A '${IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode[snapshot.bcbs_changetypecode as keyof typeof IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode]?.name}' Group Configuration Snapshot with the same effective date already exists.`,

                        onRenderDescription: OnRenderDescriptionValidationItem(
                            <>
                                Another snapshot (<LinkTo snapshot={snapshot} />) with same effective date ({formatDate(new Date(snapshot.bcbs_effectivedate!), 'en-US-ET:yyyy-MM-ddThh:mm:ssZ as local')}) and a status of Gold Standard/Data Entry Complete/Retired was found that had a conflicting change type with current snapshot.
                                <br />
                                You may consider upgrading change type.
                            </>
                        ),
                        type: EValidationSeverity.error
                    });
                });
            }
        }

        // Flow/State/Status Validation
        // ----------------------------------------------------------------------------------------------
        if (isAnotherPendingUW) {
            isAnotherPendingUW.forEach(snapshot => {

                otherValidations.push({
                    title: 'Another snapshot is currently with Underwriting. Submitting this snapshot will move it to Pending Underwriting status.',
                    onRenderDescription: OnRenderDescriptionValidationItem(
                        <div>
                            Following snapshot is with underwriting (<LinkTo snapshot={snapshot} />)
                        </div>
                    ),
                    type: EValidationSeverity.warn
                });
            });
        }

        if (isCancellation) {
            otherValidations.push({
                title: `This will close the record. Please ensure all required fields (Cancellation Date, Run out Date, etc) are complete before you continue as you will not be able to update the record afterwards.`,
                type: EValidationSeverity.warn
            });
        }

        if (forceUnderwritingReview) {
            otherValidations.push({
                title: `This Group Configuration will be set to Underwriting Review Complete status.`,
                description: `Current save will result in Group Configuration to be set to Underwriting Review Complete status.\nThis action cannot be undone.`,
                type: EValidationSeverity.warn
            });
        }

        if (isDataEntryComplete) {
            otherValidations.push({
                title: `You are submitting this snapshot for review.`,
                description: `Data entry has been complete.`,
                type: EValidationSeverity.info
            });
        }

        // // Disabling this rule, since this is no longer needed
        // // MUal: We need to disable that as part of the deployment of the new functionality , the one HVu has been working on.
        // // note: currently only applicable to prod until we take this out
        // if (Constants.env === 'prod')
        //     if (state.data.snapshot._bcbs_groupcollectfinancialconfigurationid_value) {
        //         validationMessages.push({
        //             title: `Group Collect generated Group Configuration cannot be submitted to underwriting.`,
        //             description: `A Group Configuration generated from Group Collect cannot be submitted directly to underwriting. Merge the Financial information into an existing Group Configuration to continue.`,
        //             severity: EValidationSeverity.error
        //         });
        //     }

        // BUG 301304 - Validate Opportunity on Initial Setup and Renewal
        const opportunityRequiredChanges = [
            IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Initial Setup(808900002)"].value,
            IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Comprehensive Renewal(808900001)"].value,
            IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Benefit Renewal(808900010)"].value,

            // asked for removal on email from Sebrina, RE: Items to move with special release, 03/07/2025 02:57 PM PT 
            // On a Financial Renewal change type when Financial Renewals some time ago due to the fact we have groups where the Financial Renewal Date differs from the Benefit Renewal Date and we wouldn’t have an Opportunity that matches in those cases
            // enabling again based on email from Sebrina, RE: Items to move with special release, 03/10/2025 6:58 AM PT as 424549 is already checking this
            IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Financial Renewal(808900011)"].value,
        ];

        if (state.data.json.changeType?.value)
            if (opportunityRequiredChanges.includes(state.data.json.changeType.value!))
                if (!state.data.snapshot._bcbs_opportunityid_value && !state.data.json.opportunity) {
                    otherValidations.push({
                        title: `For all Initial Setups and Renewals, an opportunity must be identified before a Group Configuration may be submitted.`,
                        description: `An opportunity must be associated with this Group Configuration Snapshot before it can be submitted to underwriting.`,
                        type: EValidationSeverity.error
                    });
                }

        if (saveInstructions.onSaveBypassUnderwritingTaskGeneration)
            otherValidations.push({
                title: `This Group Configuration will not generate any tasks.`,
                description: `This will progress the current Group Configuration to Underwriting Review Complete and prevent the generation of any tasks.  Do you wish to continue?`,
                type: EValidationSeverity.warn
            });


        if (saveInstructions.onSaveSetStatusCode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode["Pending Power User Review(808900015)"].value)
            otherValidations.push({
                title: `Submitting will assign this to the Group Library team for review.`,
                description: `A default parent cannot be identified for this Group Configuration.\nSubmitting will assign this Group Configuration to the Group Library team for review to identify the default parent.`,
                type: EValidationSeverity.warn
            });

        state.data.json.benefits.forEach(eachBenefit => {
            eachBenefit.tiers.forEach(eachBenefitTier => {
                if (eachBenefitTier.name === null || eachBenefitTier.name === '' || Tier1To4.includes(eachBenefitTier.name!)) {
                    otherValidations.push({
                        title: `Benefit (${eachBenefit.name}) tier has indistinct name (${eachBenefitTier.name}).`,
                        description: `Benefit tiers should be named distinctively and different.\nTo rename tier name, use benefit properties screen.\nSelect tier and apply correct naming and make sure attributes are correctly renamed and contain correct data.`,
                        type: EValidationSeverity.warn,
                    });
                }
            });
        });

        // OpenRevisionsResult
        // ---------------------------------------------------------
        {
            const openRevisionsResult = await dataSource.tasks_byOpenRevisions_fetchAsync(
                state.data.json.revisionTasks,
                state.data.json.effectiveDate?.value!,
                state.data.snapshot._bcbs_groupid_value!,
            );

            if (openRevisionsResult.length > 0) {
                openRevisionsResult.forEach(eachRV => {
                    otherValidations.push({
                        title: `There are open revision tasks which must be resolved prior to submission.`,
                        type: EValidationSeverity.error,
                        onRenderDescription: OnRenderDescriptionValidationItem(
                            <div>
                                <table>
                                    <tr>
                                        <td style={{ textAlign: 'right' }}>Task:</td>
                                        <td><LinkTo revisionTask={eachRV} /></td>
                                    </tr>
                                </table>
                            </div>
                        ),
                    });
                })
            }
        }

        // SBC
        // ---------------------------------------------------------
        {
            // Validate Related SBCs on Submit
            // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/436940
            // 1) Record State (statecode): Active
            // 2) Status (bcbs_sbctype): Anything other than Ready
            // 3) Manually Edited PDF (bcbs_manuallyeditedpdf): Not Yes 
            const openSBCListMemoized = await getSBCsNotReadyMemoizedAsync();

            if (openSBCListMemoized.length > 0)
                otherValidations.push({
                    title: `There are related SBC records which are not ready.`,
                    onRenderDescription: OnRenderDescriptionValidationItem(
                        <Stack tokens={{ childrenGap: '15px' }}>
                            <Text>
                                We have identified the following SBCs for the account that align with the specified criteria: active status, type not designated as ready, and Manually Edited PDF not marked as yes.
                            </Text>
                            <div>
                                {openSBCListMemoized.map((sbc, ix) => {
                                    return <div key={sbc.bcbs_sbcid}>
                                        <LinkTo sbc={sbc} /> {sbc._bcbs_group_name_value !== state.data.snapshot.bcbs_groupconfigurationsnapshotid ? "⚠ (different snapshot)" : ""}
                                    </div>
                                })}
                            </div>
                        </Stack>
                    ),
                    type: EValidationSeverity.error,
                });
        }

        // Group Configuration Properties
        // ---------------------------------------------------------
        // Validation Edit - The validation for Effective Date that runs on creation should rerun again on submit
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/550989
        const propertiesValidationResults = await ValidateGCProperties(
            dataSource,
            state,
            "change",
            state.data.json,
            {
                getSnapshotsMemoizedAsync,
                getOpportunityMemoizedAsync,
            }
        );
        otherValidations.push(...propertiesValidationResults);

        // Validation Edit - Hard Error Validation for Reconciliation Flag on an Initial Setup, Renewal or Stop Loss Change Type
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/457955
        // Display hard edit "Reconciliation Flag cannot be set for this Change Type - please remove the reconciliation flag" upon submit when the Change Type is not a Benefit Change, Financial Change or Comprehensive Change.
        if (stateJson.reconciliation?.value) {

            // Check if the change type is a Benefit Change, Financial Change or Comprehensive Change
            const changeTypeOkWithRecon = state.data.json.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Benefit Change(808900000)"].value ||
                state.data.json.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Comprehensive Change(808900004)"].value ||
                state.data.json.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Financial Change(808900006)"].value;

            if (!changeTypeOkWithRecon) {
                otherValidations.push({
                    title: `Reconciliation Flag cannot be set for this change type.`,
                    type: EValidationSeverity.error,
                    description: `The reconciliation flag is only applicable for Benefit Change, Comprehensive Change, or Financial Change types.\nPlease remove the reconciliation flag to proceed.`,
                });
            }
        }

        // Comparison - Before and After Modifications
        // ---------------------------------------------------------
        // first save of snapshot is obtained from blob history and a comparison is done with current snapshot
        // cache list of fields upon first call
        const onMergeMemoized = Memoize(async () => {
            const snapshot_json_versions = await dataSource.getSnapshotVersions(state.data.snapshot.bcbs_filename!);
            const firstVersion = snapshot_json_versions[0];
            const downloadResponse = await dataSource.downloadGroupConfigurationSnapshot(state.data.snapshot, firstVersion);
            const firstJson = downloadResponse?.json!

            const origin: IGCDataLight = {
                account: state.data.account!,
                config: stateConfig,
                json: firstJson,
                snapshot: stateSnapshot
            }

            const target: IGCDataLight = {
                account: state.data.account!,
                config: stateConfig,
                json: stateJson,
                snapshot: stateSnapshot
            }

            const compare = new ComparisonEngine(origin, target);
            const output = await compare.processAsync();
            return compare;
        });


        // Non-Standard - New nonstandards should have the same eff date as the configuration unless its a reconciliation
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/552447
        if (!state.data.json.reconciliation?.value) {

            // string values are not the same? lets compare date values
            // iso -> we want to ignore the time part from .net and treat time as start of my day
            // TODO this needs to use json effective date, not the snapshot one state.data.snapshot > state.data.json.effectiveDate?.value with coverts
            const tEffectiveDate = parseDate(stateSnapshot.bcbs_effectivedate!, 'yyyy-MM-ddThh:mm:ssZ as local');

            const validateEffectiveDate = (nonStandard: FAM_INonStandard, scopeName?: string) => {
                const getfields = getFieldsMemoByEntity(nonStandard);

                let bcbs_effectivedate_invalid = false;

                // Effective Date - Date
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=184e12d6-d38d-ec11-b400-0022480a90e0
                const bcbs_effectivedate = getfields()[$matt_$non_standard_$bcbs_effectivedate_id];

                const bcbs_effectivedate_value = bcbs_effectivedate?.[0]?.field?.values?.[0]?.value;

                if (!bcbs_effectivedate_value)
                    bcbs_effectivedate_invalid = true;

                let newEffectiveDate: Date | null = null;

                if (bcbs_effectivedate_value?.type === 'date' && bcbs_effectivedate_value?.value) {
                    // yyyy-MM-dd -> we want to add a time as start of my day
                    newEffectiveDate = parseDate(bcbs_effectivedate_value.value!, 'local:yyyy-MM-dd');

                    // Condition - effective date miss match
                    bcbs_effectivedate_invalid = tEffectiveDate.toLocaleDateString() !== newEffectiveDate.toLocaleDateString();
                }

                if (bcbs_effectivedate_invalid) {
                    otherValidations.push({
                        title: `Invalid Effective date on Non-Standard.`,
                        type: EValidationSeverity.warn,
                        description: `New Non-Standard's effective date does not match the configuration's effective date.\nNon-Standard: ${scopeName}/${nonStandard.sectionRef?.name}/${nonStandard.name}\nNon-Standard's Effective Date: ${newEffectiveDate ? formatDate(newEffectiveDate, 'en-US-ET:yyyy-MM-ddThh:mm:ssZ as local') : "N/A"}\nConfiguration Effective Date: ${formatDate(tEffectiveDate, 'en-US-ET:yyyy-MM-ddThh:mm:ssZ as local')}`,
                    });
                }
            }

            const comparisonEngine = await onMergeMemoized();

            // ROOT Level
            // ----------------------------------------------------------
            Object.entries(comparisonEngine.groupConfiguration).forEach(([id, root]) => {
                if (root.onOrigin && root.onTarget) {
                    if (root.merged?.mergedNonStandards) {
                        Object.entries(root.merged?.mergedNonStandards).forEach(([id, mergedNonStandard]) => {
                            // if its a new nonstandard for snapshot
                            if (!mergedNonStandard.onOrigin && mergedNonStandard.onTarget) {
                                const nonStandard = mergedNonStandard.onTarget;

                                if (!nonStandard.deactivated)
                                    validateEffectiveDate(nonStandard, "");
                            }
                        });
                    }
                }
            });

            // BENEFIT LEVEL
            // ----------------------------------------------------------
            // TODO rename compareResult.Benefits to compareResult.MergedBenefits
            Object.entries(comparisonEngine.benefits).forEach(([id, benefit]) => {

                // new benefit?
                if (!benefit.onOrigin && benefit.onTarget) {

                    // new nonstandards!
                    benefit.onTarget.nonStandards?.forEach(nonStandard => {
                        if (!benefit.onTarget?.deactivated && !nonStandard.deactivated)
                            validateEffectiveDate(nonStandard, benefit.onTarget?.name ?? "");
                    });
                }

                // existing benefit?
                if (benefit.onOrigin && benefit.onTarget) {
                    if (benefit.merged?.mergedNonStandards) {
                        Object.entries(benefit.merged?.mergedNonStandards).forEach(([id, mergedNonStandard]) => {

                            // new nonstandards?
                            if (!mergedNonStandard.onOrigin && mergedNonStandard.onTarget) {
                                const nonStandard = mergedNonStandard.onTarget;

                                if (!benefit.onTarget?.deactivated && !nonStandard.deactivated)
                                    validateEffectiveDate(nonStandard, benefit.onTarget?.name ?? "");
                            }
                        });
                    }

                }
            });

            // FEES AND PREMIUMS LEVEL
            // ----------------------------------------------------------
            Object.entries(comparisonEngine.feesAndPremiums).forEach(([id, feesAndPremium]) => {

                // new fees and premium?
                if (!feesAndPremium.onOrigin && feesAndPremium.onTarget) {

                    // new nonstandards!
                    feesAndPremium.onTarget.nonStandards?.forEach(nonStandard => {
                        if (!feesAndPremium.onTarget?.deactivated && !nonStandard.deactivated)
                            validateEffectiveDate(nonStandard, `Fees & Premiums/${feesAndPremium.onTarget?.name ?? ""}`);
                    });
                }

                // existing fees and premium?
                if (feesAndPremium.onOrigin && feesAndPremium.onTarget) {
                    if (feesAndPremium.merged?.mergedNonStandards) {
                        Object.entries(feesAndPremium.merged?.mergedNonStandards).forEach(([id, mergedNonStandard]) => {

                            // new nonstandards?
                            if (!mergedNonStandard.onOrigin && mergedNonStandard.onTarget) {
                                const nonStandard = mergedNonStandard.onTarget;

                                if (!feesAndPremium.onTarget?.deactivated && !nonStandard.deactivated)
                                    validateEffectiveDate(nonStandard, `Fees & Premiums/${feesAndPremium.onTarget?.name ?? ""}`);
                            }
                        });
                    }

                }
            });

            // CLAIMS AR (ACCOUNTS RECEIVABLE) LEVEL
            // ----------------------------------------------------------
            Object.entries(comparisonEngine.accountsReceivables).forEach(([id, claimsAR]) => {

                // new claims AR?
                if (!claimsAR.onOrigin && claimsAR.onTarget) {

                    // new nonstandards!
                    claimsAR.onTarget.nonStandards?.forEach(nonStandard => {
                        if (!claimsAR.onTarget?.deactivated && !nonStandard.deactivated)
                            validateEffectiveDate(nonStandard, `Accounts Receivable/${claimsAR.onTarget?.name ?? ""}`);
                    });
                }

                // existing claims AR?
                if (claimsAR.onOrigin && claimsAR.onTarget) {
                    if (claimsAR.merged?.mergedNonStandards) {
                        Object.entries(claimsAR.merged?.mergedNonStandards).forEach(([id, mergedNonStandard]) => {

                            // new nonstandards?
                            if (!mergedNonStandard.onOrigin && mergedNonStandard.onTarget) {
                                const nonStandard = mergedNonStandard.onTarget;

                                if (!claimsAR.onTarget?.deactivated && !nonStandard.deactivated)
                                    validateEffectiveDate(nonStandard, `Accounts Receivable/${claimsAR.onTarget?.name ?? ""}`);
                            }
                        });
                    }

                }
            });

            // StopLoss LEVEL
            // ----------------------------------------------------------
            Object.entries(comparisonEngine.stopLosses).forEach(([id, eachStopLoss]) => {

                // new claims AR?
                if (!eachStopLoss.onOrigin && eachStopLoss.onTarget) {

                    // new nonstandards!
                    eachStopLoss.onTarget.nonStandards?.forEach(nonStandard => {
                        if (!eachStopLoss.onTarget?.deactivated && !nonStandard.deactivated)
                            validateEffectiveDate(nonStandard, `StopLoss/${eachStopLoss.onTarget?.name ?? ""}`);
                    });
                }

                // existing stopLoss?
                if (eachStopLoss.onOrigin && eachStopLoss.onTarget) {
                    if (eachStopLoss.merged?.mergedNonStandards) {
                        Object.entries(eachStopLoss.merged?.mergedNonStandards).forEach(([id, mergedNonStandard]) => {

                            // new nonstandards?
                            if (!mergedNonStandard.onOrigin && mergedNonStandard.onTarget) {
                                const nonStandard = mergedNonStandard.onTarget;

                                if (!eachStopLoss.onTarget?.deactivated && !nonStandard.deactivated)
                                    validateEffectiveDate(nonStandard, `StopLoss/${eachStopLoss.onTarget?.name ?? ""}`);
                            }
                        });
                    }
                }
            });



            //NON-STANDARD CHECK BENEFIT DEF FOR EMPTY - CHANGE AS OF: https://dev.azure.com/blue-infosys/Group%20Library/_sprints/taskboard/Group%20Library%20Team/Group%20Library/Sprint%2042?workitem=647798
            const validateBenefitDefinitionsOnTargetNonstandard = (nonStandard: FAM_INonStandard, scopeName?: string) => {
                const fields = FieldsToLookupByMasterAttributeId(stateConfig, nonStandard.fields);

                let bcbs_benefitDefinition_invalid = false;

                // benefitDef
                // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=184e12d6-d38d-ec11-b400-0022480a90e0
                const bcbs_benefitdefinition_masterfields = fields[$matt_$non_standard_$bcbs_benefitdefinition_id];
                const bcbs_benefitdefinition = bcbs_benefitdefinition_masterfields?.length > 0
                    ? bcbs_benefitdefinition_masterfields[0].field
                    : null;

                const bcbs_benefitdefinition_value = bcbs_benefitdefinition && bcbs_benefitdefinition.values?.[0].value?.type === 'string'
                    ? bcbs_benefitdefinition.values?.[0].value
                    : null;

                if (!bcbs_benefitdefinition_value || (bcbs_benefitdefinition_value.value && bcbs_benefitdefinition_value.value.trim().length === 0)) {
                    bcbs_benefitDefinition_invalid = true;
                }

                if (bcbs_benefitDefinition_invalid) {
                    otherValidations.push({
                        title: `Non-Standard Benefit Definition is Empty.`,
                        type: EValidationSeverity.error,
                        description: `Non-Standard Benefit Definition is Empty.\nNon-Standard: ${scopeName}/${nonStandard.sectionRef?.name}/${nonStandard.name}')}`,
                    });
                }

            }

            // ROOT Level
            // ----------------------------------------------------------
            Object.entries(comparisonEngine.groupConfiguration).forEach(([id, root]) => {
                if (root.onOrigin && root.onTarget) {
                    if (root.merged?.mergedNonStandards) {
                        Object.entries(root.merged?.mergedNonStandards).forEach(([id, mergedNonStandard]) => {
                            // if its a new nonstandard for snapshot
                            if (!mergedNonStandard.onOrigin && mergedNonStandard.onTarget) {
                                const nonStandard = mergedNonStandard.onTarget;

                                if (!nonStandard.deactivated)
                                    validateBenefitDefinitionsOnTargetNonstandard(nonStandard, "");
                            }
                        });
                    }
                }
            });

            // Plan Level
            // ----------------------------------------------------------


            Object.entries(comparisonEngine.plans).forEach(([id, plan]) => {

                // new plan?
                if (!plan.onOrigin && plan.onTarget) {

                    // new nonstandards!
                    plan.onTarget.nonStandards?.forEach(nonStandard => {
                        if (!plan.onTarget?.deactivated && !nonStandard.deactivated)
                            validateBenefitDefinitionsOnTargetNonstandard(nonStandard, `Plan/${plan.onTarget?.name ?? ""}`);
                    });
                }

                // existing plan?
                if (plan.onOrigin && plan.onTarget) {
                    if (plan.merged?.mergedNonStandards) {
                        Object.entries(plan.merged?.mergedNonStandards).forEach(([id, mergedNonStandard]) => {

                            // new nonstandards?
                            if (!mergedNonStandard.onOrigin && mergedNonStandard.onTarget) {
                                const nonStandard = mergedNonStandard.onTarget;
                                if (!plan.onTarget?.deactivated && !nonStandard.deactivated)
                                    validateBenefitDefinitionsOnTargetNonstandard(nonStandard, `Plan/${plan.onTarget?.name ?? ""}`);
                            }
                        });
                    }
                }
            });


            // BENEFIT LEVEL
            // ----------------------------------------------------------
            // TODO rename compareResult.Benefits to compareResult.MergedBenefits
            Object.entries(comparisonEngine.benefits).forEach(([id, benefit]) => {

                // new benefit?
                if (!benefit.onOrigin && benefit.onTarget) {

                    // new nonstandards!
                    benefit.onTarget.nonStandards?.forEach(nonStandard => {
                        if (!benefit.onTarget?.deactivated && !nonStandard.deactivated)
                            validateBenefitDefinitionsOnTargetNonstandard(nonStandard, benefit.onTarget?.name ?? "");
                    });
                }

                // existing benefit?
                if (benefit.onOrigin && benefit.onTarget) {
                    if (benefit.merged?.mergedNonStandards) {
                        Object.entries(benefit.merged?.mergedNonStandards).forEach(([id, mergedNonStandard]) => {

                            // new nonstandards?
                            if (!mergedNonStandard.onOrigin && mergedNonStandard.onTarget) {
                                const nonStandard = mergedNonStandard.onTarget;

                                if (!benefit.onTarget?.deactivated && !nonStandard.deactivated)
                                    validateBenefitDefinitionsOnTargetNonstandard(nonStandard, benefit.onTarget?.name ?? "");
                            }
                        });
                    }

                }
            });

            // FEES AND PREMIUMS LEVEL - Benefit Definitions
            // ----------------------------------------------------------
            Object.entries(comparisonEngine.feesAndPremiums).forEach(([id, feesAndPremium]) => {

                // new fees and premium?
                if (!feesAndPremium.onOrigin && feesAndPremium.onTarget) {

                    // new nonstandards!
                    feesAndPremium.onTarget.nonStandards?.forEach(nonStandard => {
                        if (!feesAndPremium.onTarget?.deactivated && !nonStandard.deactivated)
                            validateBenefitDefinitionsOnTargetNonstandard(nonStandard, `Fees & Premiums/${feesAndPremium.onTarget?.name ?? ""}`);
                    });
                }

                // existing fees and premium?
                if (feesAndPremium.onOrigin && feesAndPremium.onTarget) {
                    if (feesAndPremium.merged?.mergedNonStandards) {
                        Object.entries(feesAndPremium.merged?.mergedNonStandards).forEach(([id, mergedNonStandard]) => {

                            // new nonstandards?
                            if (!mergedNonStandard.onOrigin && mergedNonStandard.onTarget) {
                                const nonStandard = mergedNonStandard.onTarget;

                                if (!feesAndPremium.onTarget?.deactivated && !nonStandard.deactivated)
                                    validateBenefitDefinitionsOnTargetNonstandard(nonStandard, `Fees & Premiums/${feesAndPremium.onTarget?.name ?? ""}`);
                            }
                        });
                    }

                }
            });

            // CLAIMS AR (ACCOUNTS RECEIVABLE) LEVEL - Benefit Definitions
            // ----------------------------------------------------------
            Object.entries(comparisonEngine.accountsReceivables).forEach(([id, claimsAR]) => {

                // new claims AR?
                if (!claimsAR.onOrigin && claimsAR.onTarget) {

                    // new nonstandards!
                    claimsAR.onTarget.nonStandards?.forEach(nonStandard => {
                        if (!claimsAR.onTarget?.deactivated && !nonStandard.deactivated)
                            validateBenefitDefinitionsOnTargetNonstandard(nonStandard, `Accounts Receivable/${claimsAR.onTarget?.name ?? ""}`);
                    });
                }

                // existing claims AR?
                if (claimsAR.onOrigin && claimsAR.onTarget) {
                    if (claimsAR.merged?.mergedNonStandards) {
                        Object.entries(claimsAR.merged?.mergedNonStandards).forEach(([id, mergedNonStandard]) => {

                            // new nonstandards?
                            if (!mergedNonStandard.onOrigin && mergedNonStandard.onTarget) {
                                const nonStandard = mergedNonStandard.onTarget;

                                if (!claimsAR.onTarget?.deactivated && !nonStandard.deactivated)
                                    validateBenefitDefinitionsOnTargetNonstandard(nonStandard, `Accounts Receivable/${claimsAR.onTarget?.name ?? ""}`);
                            }
                        });
                    }

                }
            });

            // StopLoss LEVEL - Benefit Definitions
            // ----------------------------------------------------------
            Object.entries(comparisonEngine.stopLosses).forEach(([id, eachStopLoss]) => {

                // new stopLoss?
                if (!eachStopLoss.onOrigin && eachStopLoss.onTarget) {
                    // new nonstandards!
                    eachStopLoss.onTarget.nonStandards?.forEach(nonStandard => {
                        if (!eachStopLoss.onTarget?.deactivated && !nonStandard.deactivated)
                            validateBenefitDefinitionsOnTargetNonstandard(nonStandard, `StopLoss/${eachStopLoss.onTarget?.name ?? ""}`);
                    });
                }

                // existing stopLoss?
                if (eachStopLoss.onOrigin && eachStopLoss.onTarget) {
                    if (eachStopLoss.merged?.mergedNonStandards) {
                        Object.entries(eachStopLoss.merged?.mergedNonStandards).forEach(([id, mergedNonStandard]) => {
                            // new nonstandards?
                            if (!mergedNonStandard.onOrigin && mergedNonStandard.onTarget) {
                                const nonStandard = mergedNonStandard.onTarget;
                                if (!eachStopLoss.onTarget?.deactivated && !nonStandard.deactivated)
                                    validateBenefitDefinitionsOnTargetNonstandard(nonStandard, `StopLoss/${eachStopLoss.onTarget?.name ?? ""}`);
                            }
                        });
                    }
                }
            });
        }

        // **** Background Worker Approach ****
        // this is proof of concept, if it becomes a bottleneck we can use worker approach
        // ************************************
        // const worker = new Worker();
        // const workerResponseAsync = new Promise((resolve, reject) => {

        //     const timer = setTimeout(() => {
        //         // worker.terminate();
        //         // worker.removeEventListener("message", handleMessageFromWorker);
        //         reject(new Error("Timeout waiting for worker response"));
        //     }, 10000);

        //     const handleMessageFromWorker = (msg: MessageEvent) => {
        //         clearTimeout(timer);
        //         resolve(msg.data);
        //     }

        //     worker.addEventListener("message", handleMessageFromWorker);
        //     worker.postMessage({ type: 'json', payload: { origin: json, target: state.data.json } });
        // });
        // const response = await workerResponseAsync;
        // worker.terminate();

        {
            // Required Fields
            // ----------------------------------------------------------
            const valEngine = new ValidationEngine(state.data);
            await valEngine.processAsync();

            valEngine.requiredFieldsResults.forEach(eachValidation => {

                const section = eachValidation.bcbs_config_attribute._bcbs_config_sectionid_value
                    ? state.data.config.cache.map_bcbs_config_section[eachValidation.bcbs_config_attribute._bcbs_config_sectionid_value]
                    : undefined;

                const tab = section?._bcbs_config_tabid_value
                    ? state.data.config.cache.map_bcbs_config_tab[section._bcbs_config_tabid_value]
                    : undefined;

                const scopes = [...eachValidation.scope];

                if (tab && tab.bcbs_name) {
                    scopes.push(`Tab: ${tab.bcbs_name}`);
                }

                if (section && section.bcbs_name) {
                    scopes.push(`Section: ${section.bcbs_name}`);
                }

                if (eachValidation.bcbs_config_attribute.bcbs_label) {
                    scopes.push(eachValidation.bcbs_config_attribute.bcbs_label);
                }

                if (eachValidation.tierRefName) {
                    scopes.push(`(Tier: ${eachValidation.tierRefName})`);
                }

                otherValidations.push({
                    title: `${eachValidation.bcbs_config_attribute.bcbs_label} is required.`,
                    type: eachValidation.type,
                    description: `Field has been marked as required, \n${scopes.join(" > ")}`,
                });

            });

            valEngine.expiredFieldsResults.forEach(eachValidation => {

                const section = eachValidation.bcbs_config_attribute._bcbs_config_sectionid_value
                    ? state.data.config.cache.map_bcbs_config_section[eachValidation.bcbs_config_attribute._bcbs_config_sectionid_value]
                    : undefined;

                const tab = section?._bcbs_config_tabid_value
                    ? state.data.config.cache.map_bcbs_config_tab[section._bcbs_config_tabid_value]
                    : undefined;

                const scopes = [...eachValidation.scope];

                if (tab && tab.bcbs_name) {
                    scopes.push(`Tab: ${tab.bcbs_name}`);
                }

                if (section && section.bcbs_name) {
                    scopes.push(`Section: ${section.bcbs_name}`);
                }

                if (eachValidation.bcbs_config_attribute.bcbs_label)

                    otherValidations.push({
                        title: `${eachValidation.bcbs_config_attribute.bcbs_label} has invalid value.`,
                        type: eachValidation.type,
                        description: `Field has been marked as having an expired value (${eachValidation.optionSetItem.bcbs_name}), \n${scopes.join(" > ")}`,
                    });
            });
        }
    }

    return resultValidations;
}

const isChangeTypeCodeRenewal = (changeTypeCode: number) => {
    return changeTypeCode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Benefit Renewal(808900010)"].value ||
        changeTypeCode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Financial Renewal(808900011)"].value ||
        changeTypeCode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Comprehensive Renewal(808900001)"].value;
}

const isStatusCodeInProgress = (statusCode: number) => {
    return statusCode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['In Progress(1)'].value ||
        statusCode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Data Entry Complete(808900000)'].value ||
        statusCode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Corrections Pending(808900005)'].value ||
        statusCode === IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Pending Underwriting(808900009)'].value;
}

export async function ValidateGCProperties(
    dataSource: AppDataSource,
    state: RootState,
    actionType: "setup" | "change",
    updatedProperties: IGroupConfigurationDataProperties,
    cache?: IMemoCache
) {
    const validationMessages: IValidationMessage[] = [];

    const getSnapshotsMemoizedAsync = cache?.getSnapshotsMemoizedAsync ?? MemoizeAsync(async () => {
        return await dataSource.getGroupConfigurationSnapshotsForAccount(state.data.account?.accountid!);
    });

    const getOpportunityMemoizedAsync = cache?.getOpportunityMemoizedAsync ?? MemoizeAsync(async () => {
        if (updatedProperties.opportunity?.id)
            return await dataSource.opportunities_byId_getAsync(updatedProperties.opportunity.id);

        if (state.data.snapshot._bcbs_opportunityid_value)
            return await dataSource.opportunities_byId_getAsync(state.data.snapshot._bcbs_opportunityid_value)
    });


    // we need to get latest, incase someone has 
    // created a new snapshot while we were working on this one
    const snapshotsMemoized = await getSnapshotsMemoizedAsync();

    const updatedProperties_isRenewal = updatedProperties.changeType?.value && isChangeTypeCodeRenewal(updatedProperties.changeType.value);

    const updatedProperties_isInitialSetup = updatedProperties.changeType?.value && (
        updatedProperties.changeType.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Initial Setup(808900002)"].value
    );

    let anyBenefitRenewalWithSameEffectiveDate = false;
    let anyFinancialRenewalWithSameEffectiveDate = false;

    // yyyy-MM-dd -> we want to add a time as start of my day
    const updatedProperties_effectiveDate = parseDate(updatedProperties.effectiveDate?.value!, 'local:yyyy-MM-dd');

    const currentSnapshot_parents: string[] = [];

    if (actionType === 'change') {
        // we are validating an existing snapshot, so we need to check if it has any parents
        if (state.data.snapshot._bcbs_originatingsnapshotid_value)
            currentSnapshot_parents.push(state.data.snapshot._bcbs_originatingsnapshotid_value);

        if (state.data.snapshot._bcbs_originatingsnapshot2id_value)
            currentSnapshot_parents.push(state.data.snapshot._bcbs_originatingsnapshot2id_value);
    } else if (actionType === 'setup') {
        // we are validating creation of a new snapshot, so current snapshot becomes a parent of the new snapshot
        if (state.data.snapshot.bcbs_groupconfigurationsnapshotid)
            currentSnapshot_parents.push(state.data.snapshot.bcbs_groupconfigurationsnapshotid);
    }

    snapshotsMemoized.forEach(eachSnapshot => {

        // same snapshot as currently loaded one?
        const eachSnapshot_isCurrentSnapshot = (eachSnapshot.bcbs_groupconfigurationsnapshotid === state.data.snapshot.bcbs_groupconfigurationsnapshotid);

        const eachSnapshot_isInProgress = eachSnapshot.statuscode && isStatusCodeInProgress(eachSnapshot.statuscode);

        // Condition - not a Data Entry Complete/Gold Standard/Retired
        const eachSnapshot_isRenewal = eachSnapshot.bcbs_changetypecode && isChangeTypeCodeRenewal(eachSnapshot.bcbs_changetypecode);
        const eachSnapshot_isInitialSetup = eachSnapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Initial Setup(808900002)"].value;

        const eachSnapshot_isInactive = eachSnapshot.statuscode == IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode['Inactive(808900002)'].value;

        // string values are not the same? lets compare date values
        // iso -> we want to ignore the time part from .net and treat time as start of my day
        const eachSnapshot_EffectiveDate = parseDate(eachSnapshot.bcbs_effectivedate!, 'yyyy-MM-ddThh:mm:ssZ as local');


        // Condition - effective date miss match
        const eachSnapshot_and_updatedProperties_effectiveDateMatch = eachSnapshot_EffectiveDate.toLocaleDateString() === updatedProperties_effectiveDate.toLocaleDateString();

        // Rules:
        // ---------------------------------------------------------------------------

        // Change Type - Do Not Allow Initial Setup and Renewal
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/348374
        if (updatedProperties_isRenewal && eachSnapshot_isInitialSetup && eachSnapshot_and_updatedProperties_effectiveDateMatch && !eachSnapshot_isInactive) {
            validationMessages.push({
                title: `A Renewal cannot have the same effective date as the Initial Setup.`,
                type: EValidationSeverity.error,
                onRenderDescription: OnRenderDescriptionValidationItem(
                    <div>
                        Initial Setup: <LinkTo snapshot={eachSnapshot} />
                    </div>
                ),
            });
        }

        // complementary to the rule above
        if (updatedProperties_isInitialSetup && eachSnapshot_isRenewal && eachSnapshot_and_updatedProperties_effectiveDateMatch) {
            validationMessages.push({
                title: `An Initial Setup cannot have the same effective date as the Renewal.`,
                type: EValidationSeverity.error,
                onRenderDescription: OnRenderDescriptionValidationItem(
                    <div>
                        Renewal: <LinkTo snapshot={eachSnapshot} />
                    </div>
                ),
            });
        }

        // Prevent Creating Group Configuration When Same Effective Date Exists In progress
        // https://dev.azure.com/blue-infosys/Group%20Library/_sprints/taskboard/Group%20Library%20Team/Group%20Library/Sprint%2012?workitem=360979
        if (!eachSnapshot_isCurrentSnapshot && eachSnapshot_and_updatedProperties_effectiveDateMatch && eachSnapshot_isInProgress)
            validationMessages.push({
                title: `Another conflicting Group Configuration Snapshot has been identified.`,
                type: EValidationSeverity.warn,
                onRenderDescription: OnRenderDescriptionValidationItem(
                    <div>
                        <div>
                            A Group Configuration Snapshot (<LinkTo snapshot={eachSnapshot} />) with the same effective date is currently being worked on.
                        </div>
                        <div>
                            Please incorporate your changes into one Configuration.
                        </div>
                    </div>
                ),
            });

        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/346382
        // effective date of parent snapshot should be before current snapshots effective date
        // if parent && props.variant === 'setup' && ?
        if (
            (actionType === 'setup' && eachSnapshot_isCurrentSnapshot) ||
            (actionType === 'change' && state.data.snapshot._bcbs_originatingsnapshotid_value === eachSnapshot.bcbs_groupconfigurationsnapshotid) ||
            (actionType === 'change' && state.data.snapshot._bcbs_originatingsnapshot2id_value === eachSnapshot.bcbs_groupconfigurationsnapshotid)
        ) {
            if (updatedProperties_effectiveDate.getTime() < eachSnapshot_EffectiveDate.getTime()) {
                validationMessages.push({
                    title: 'Invalid Effective Date.',
                    type: EValidationSeverity.error,
                    onRenderDescription: OnRenderDescriptionValidationItem(
                        <div>
                            A Group Configuration Snapshot may not have an effective date that is earlier than the Effective Date of its parent Group Configuration Snapshot(s).
                            <br />
                            <LinkTo snapshot={eachSnapshot} />
                        </div>
                    ),
                });
            }
        }

        // TODO the status of the snapshot matters
        if (
            // 688903: it is acceptable for current snapshot to be a fin/ben renewal
            // !t_isCurrentSnapshot &&
            eachSnapshot_and_updatedProperties_effectiveDateMatch &&
            eachSnapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Financial Renewal(808900011)"].value &&
            eachSnapshot.statuscode !== IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode["Inactive(808900002)"].value
        ) {
            anyFinancialRenewalWithSameEffectiveDate = true;
        }

        if (
            // 688903: it is acceptable for current snapshot to be a fin/ben renewal
            // !t_isCurrentSnapshot && 
            eachSnapshot_and_updatedProperties_effectiveDateMatch &&
            eachSnapshot.bcbs_changetypecode === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Benefit Renewal(808900010)"].value &&
            eachSnapshot.statuscode !== IXrmOptions_bcbs_groupconfigurationsnapshot.statuscode["Inactive(808900002)"].value
        ) {
            anyBenefitRenewalWithSameEffectiveDate = true;
        }

        // Validation Edit - Configuration Snapshot - Prevent User from creating snapshot using same Parent with hard edit
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/670195
        // Regardless of the Effective Dates a user should NOT be able to have 2 Snapshots in Progress that use the same Parent Snapshot. For example, if BMW has a 1/1/2026 EDGS, a user should not be able to create a Benefit Change for 6/1/2026 AND 9/1/2026 at the same time using the 1/1/2026 EDGS.
        if (!eachSnapshot_isCurrentSnapshot &&
            !eachSnapshot_isInactive &&
            eachSnapshot_isInProgress &&
            (
                (eachSnapshot._bcbs_originatingsnapshotid_value && currentSnapshot_parents.includes(eachSnapshot._bcbs_originatingsnapshotid_value)) ||
                (eachSnapshot._bcbs_originatingsnapshot2id_value && currentSnapshot_parents.includes(eachSnapshot._bcbs_originatingsnapshot2id_value))
            )
        ) {
            validationMessages.push({
                title: `Another conflicting Group Configuration Snapshot has been identified.`,
                type: EValidationSeverity.error,
                onRenderDescription: OnRenderDescriptionValidationItem(
                    <div>
                        <div>
                            A Group Configuration Snapshot (<LinkTo snapshot={eachSnapshot} />) with the same parent snapshot is currently being worked on.
                        </div>
                        <div>
                            Please incorporate your changes into one Configuration.
                        </div>
                    </div>
                ),
            });
        }

    });

    // Validation Edit - renewal change type
    // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/578388
    // Marketing reps are creating comprehensive change types before benefit and financial renewals are completed. 
    // If a user creates a Comprehensive Change with an Effective Date the same as a Benefit Renewal but there is no Financial Renewal with that same Effective Date, 
    // show a validation warning: "It does not appear that the Financial Renewal has been created. Confirm before Submitting."
    if (
        updatedProperties.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Comprehensive Change(808900004)"].value
    ) {
        if (anyBenefitRenewalWithSameEffectiveDate && !anyFinancialRenewalWithSameEffectiveDate) {
            validationMessages.push({
                title: `Financial Renewal has not been created.`,
                type: EValidationSeverity.warn,
                description: `It does not appear that the Financial Renewal has been created. Confirm before Submitting.\nThis is a Comprehensive Change with an Effective Date the same as a Benefit Renewal but there is no Financial Renewal with that same Effective Date`,
            });
        }
    }

    // Validation
    // BUG 319455 - Group Configuration - Opportunity Validation
    if (
        updatedProperties.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Initial Setup(808900002)"].value ||
        updatedProperties.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["MNIL  Renewal Continuation(808900008)"].value ||
        updatedProperties.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Benefit Renewal(808900010)"].value ||
        updatedProperties.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Financial Renewal(808900011)"].value ||
        updatedProperties.changeType?.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Comprehensive Renewal(808900001)"].value
    ) {
        let opportunityMemoized = await getOpportunityMemoizedAsync();

        if (opportunityMemoized && opportunityMemoized.estimatedclosedate && updatedProperties.effectiveDate?.value) {
            const opportunityEffectiveDate = parseDate(opportunityMemoized!.estimatedclosedate!, 'yyyy-MM-ddThh:mm:ssZ as local');
            const jsonEffectiveDate = parseDate(updatedProperties.effectiveDate?.value!, 'local:yyyy-MM-dd');

            const delta = opportunityEffectiveDate.getTime() - jsonEffectiveDate.getTime();

            if (delta !== 0) {
                const t: IValidationMessage = {
                    title: `Effective Date does not match the Effective Date of the related Opportunity.`,
                    onRenderDescription: OnRenderDescriptionValidationItem(
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td style={{ textAlign: 'right' }}>Opportunity</td>
                                        <td><LinkTo opportunity={opportunityMemoized} /></td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'right' }}>Group Configuration Effective Date</td>
                                        <td>{formatDate(jsonEffectiveDate, 'en-US-ET:yyyy-MM-ddThh:mm:ssZ as local')}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'right' }}>Related Opportunity Effective Date</td>
                                        <td>{formatDate(opportunityEffectiveDate, 'en-US-ET:yyyy-MM-ddThh:mm:ssZ as local')}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    ),
                    type: EValidationSeverity.error
                };

                // show warning for Financial Renewal
                // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/424549
                if (updatedProperties.changeType.value === IXrmOptions_bcbs_groupconfigurationsnapshot.bcbs_changetypecode["Financial Renewal(808900011)"].value)
                    t.type = EValidationSeverity.warn

                validationMessages.push(t);
            }
        }
    }


    if (state.status.debug.admin) {
        validationMessages.push({
            title: `(Admin) mode is on.`,
            description: `When using admin mode you can continue with saving the data.\nValidations can not prevent bad data submission.`,
            type: EValidationSeverity.warn,
        });
    }

    return validationMessages;
}
